import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { apiCallsCommercial } from '../../utils/apiCallsCommercial'
import { getUrlParameter } from '../../utils/helpers'
import { cloneDeep } from 'lodash'
import Modal from '../../components/modal/Modal'
import GlobalOverlay from '../../components/global-overlay/GlobalOverlay'
import BreakerDetailsFormContainerResidential from '../../components/config-chassis/residential/BreakerDetailsFormContainerResidential'
import AdditionalItemsFormContainer from '../../components/config-chassis/residential/AdditionalItemsFormContainer'
import BusBarFormContainer from '../../components/config-chassis/residential/BusBarFormContainer'
import commonFunctionsService from '../../services/CommonFunctionsService'
import ChassisBoardResidential from '../../components/config-chassis/residential/ChassisBoardResidential'
import Breaker from '../../components/config-chassis/residential/Breaker'
import Contactor from '../../components/config-chassis/residential/Contactor'
import FittedOption from '../../components/config-chassis/residential/FittedOption'
import BoardDetailsResidential from '../project-details/residential/BoardDetails'
import HeaderLogo from '../../components/header-logo/HeaderLogo'
import HeaderBrandCommercial from '../../components/header-brand-commercial/HeaderBrandCommercial'
import HeaderBrandResidential from '../../components/header-brand-residential/HeaderBrandResidential'
import { Player } from '@lottiefiles/react-lottie-player'
import { apiCallsResidential } from '../../utils/apiCallsResidential'
import BoardService from './../../services/BoardService'
import { getNumberOfRowsFromPolesString, getPolesCountFromPolesString, canAddDeviceToBoardPosition } from './../../utils/helpers'
import analyticsDataLayer from '../../services/AnalyticsDataLayer'

const { CONST } = require('../../CONST')

const SAMPLE_BREAKER = {
    "ProjectBoardID": 0,
    "BreakerTypeItemID": 0,
    "ChassisIndex": 0,
    "ChassisPositionIndex": 0,
    "BreakerCircuitLabel": "",
    "Chassis1PercentComplete": 0,
    "Chassis2PercentComplete": 0,
    "BreakerTypeReadOnly": {
        "ItemID": 0,
        "TypeCode": "0",
        "TypeCodeLabel": null,
        "BreakerReference": "0",
        "BreakerReferenceLabel": null,
        "DrawingDesc": "0",
        "DrawingDescLabel": null,
        "PoleCount": 0,
        "PoleCountLabel": "",
        "CurrentRating": 0,
        "CurrentRatingLabel": null,
        "PitchPoleSize": 0
    },
    "ParentBreakerTypeItemID": 0,
    "ParentBreakerCurrentRating": 0,
    "ParentBoardBreakerItemID": 0,
    "BreakerIsParent": false,
    "ItemID": 0,
    "ItemGUID": "",
    "IsDeleted": false
}

const SAMPLE_CONTRACTOR = {
    "ProjectBoardID": 0,
    "ContractorItemID": 0,
    "ProjectID": 0,
    "RowIndex": 0,
    "PoleIndex": 0,
    "BreakerCircuitLabel": "",
    "ContractorReadOnly": {
        "ItemID": 0,
        "TypeOfDevice": "",
        "CurrentRating": "",
        "Description": "",
        "Rating": "",
        "SpaceUsed": 0,
        "Image": ""
    },
    "ItemID": 0,
    "ItemGUID": "",
    "IsDeleted": false
}

const SAMPLE_FITTED_OPTION = {
    "ProjectBoardID": 0,
    "ProjectID": 0,
    "FittedOptionItemID": 0,
    "RowIndex": 0,
    "PoleIndex": 0,
    "BreakerCircuitLabel": "",
    "FittedOptionReadOnly": {
        "TypeOfDevice": "",
        "Rating": "",
        "Reference": "",
        "Description": "",
        "SpaceUsed": "",
        "ItemID": 0,
        "ItemGUID": "",
        "IsDeleted": false
    },
    "ItemID": 0,
    "ItemGUID": "",
    "IsDeleted": false
}


class ConfigChassisResidential extends Component {
    constructor(props) {
        super(props)

        this.addBreaker = this.addBreaker.bind(this)
        this.saveContactor = this.saveContactor.bind(this)
        this.saveFittedOption = this.saveFittedOption.bind(this)
        this.deleteBreakerFromBoard = this.deleteBreakerFromBoard.bind(this)
        this.deleteContactorFromBoard = this.deleteContactorFromBoard.bind(this)
        this.deleteFittedOptionFromBoard = this.deleteFittedOptionFromBoard.bind(this)
        this.togglePowerTag = this.togglePowerTag.bind(this)
        this.updateBrekerChassisNote = this.updateBrekerChassisNote.bind(this)
        this.updateContactorChassisNote = this.updateContactorChassisNote.bind(this)
        this.updateFittedOptionChassisNote = this.updateFittedOptionChassisNote.bind(this)
        this.updateBreakerPosition = this.updateBreakerPosition.bind(this)
        this.updateContactorPosition = this.updateContactorPosition.bind(this)
        this.updateFittedOptionPosition = this.updateFittedOptionPosition.bind(this)
        this.updateMainSwitchPosition = this.updateMainSwitchPosition.bind(this)
        this.updateWiserEnergyGatewayPosition = this.updateWiserEnergyGatewayPosition.bind(this)
        this.removeBusbar = this.removeBusbar.bind(this)
        this.onScroll = this.onScroll.bind(this)
        this.scrollRef = React.createRef()

        this.state = {
            projectID: '',
            boardID: '',
            board: {},
            boardDetails: {}, // Contains more details (from boardOptionData) based on user selections
            boardOptions: {},
            boardOptionData: [],
            boardToConfigure: {},
            shouldRedirectToBoard: false,
            project: {},
            miscParts: [],
            fittedOptions: [],
            breakerOptionData: [],
            residentialAllPartsAvailable: [],
            breakerOptions: [],
            userId: 0,
            userData: {},
            favBreakers: [],
            isLoading: true,
            apiError: '',
            isBreakerModalOpen: false,
            isAdditionalItemsModalOpen: false,
            isBusbarModalOpen: false,
            activeBreakersTab: 'all', // all, favourites, boardonly (boardonly indicates all breakers added to the board minus favourites)
            isDragAndDropEnabled: true,
            editedBreaker: {
                idInCollection: null,
                isFav: false
            },
            boardPolesTotal: 0,
            boardPolesConfigured: 0,
            boardPolesRemaining: 0,
            boardCompletionPercentage: 0,
            pageInfo: '',
            displayMaxBoardLimitReached: '',
            isConfiguringBoard: false,
            isAddingDevice: [],
            isUpdatingDevice: false,
            isAddingBusBar: false,
            hasAlreadyShownEnoughQuoteInfo: false,
            showDragNDropTutorial: false,
            scrollTop: 0,
            isEditingPowerTags: false,
            hasMixedDifferentProductRanges: false
        }
    }

    componentDidMount() {
        this.setState({
            projectID: getUrlParameter('projectID'),
            boardID: getUrlParameter('boardID')
        }, () => {
            this.initialize()
        })
    }

    componentDidUpdate() {
        if (this.scrollRef.current !== null) {
            this.scrollRef.current.scrollTop = this.state.scrollTop
        }
    }

    initialize() {
        // Load the API data after mounting so the spinner gets rendered first
        apiCallsResidential.apiGetProject(this.state.projectID)
            .then(projectData => {
                this.setState({ project: projectData })

                return apiCallsResidential.apiGetBoard(this.state.projectID, this.state.boardID)
            })
            .then(boardData => {
                this.setState({ board: boardData }, () => this.checkForDifferentProductRanges())

                return apiCallsResidential.apiGetBoardOption() // Load the breaker options
            })
            .then(boardOptionData => {
                const boardDetails = BoardService.getDetails(boardOptionData,
                    this.state.board.EnclosureID, this.state.board.MainSwitchID, this.state.board.SPDID, this.state.board.MetalBlackPlateID)

                const boardCompletionDetails = BoardService.getBoardCompletionDetails(this.state.board, boardDetails)
                this.setState({
                    boardOptionData: boardOptionData,
                    boardDetails: boardDetails,
                    boardPolesTotal: boardCompletionDetails.totalPoles,
                    boardPolesConfigured: boardCompletionDetails.totalPolesConfigured,
                    boardPolesRemaining: boardCompletionDetails.totalPolesRemaining,
                    boardCompletionPercentage: boardCompletionDetails.completionPercentage
                })

                return apiCallsResidential.apiGetBoardOptionLabels()
            })
            .then(boardOptionLabels => {
                this.setState({ boardOptions: boardOptionLabels })

                return apiCallsResidential.apiGetBreakerOptions()
            })
            .then(breakerTypeData => {
                this.setState({ breakerOptionData: breakerTypeData })

                // Load the board misc parts after the project has been loaded
                return apiCallsResidential.apiGetBreakerOptionLabels()
            })
            .then(breakerTypeLabelsData => {
                this.setState({ breakerOptions: breakerTypeLabelsData })

                // Load the board misc parts after the project has been loaded
                return apiCallsResidential.apiGetBoardMiscParts()
            })
            .then(miscData => {
                // As for now we are disabling powertags, so we need to filter all fitted options of TypeOfDevice: 'Powertag control' from the miscDat.FittedOptions
                const filteredFittedOptions = miscData.FittedOptions.filter(item => item.TypeOfDevice !== 'Powertag control')

                this.setState({
                    fittedOptions: filteredFittedOptions,
                    miscParts: miscData.LooseSupplyItems
                }, () => console.log('fittedOptions', this.state.fittedOptions))

                return apiCallsResidential.apiGetBusBars()
            })
            .then(busbars => {
                this.setState({ busbarsData: busbars })

                return apiCallsResidential.apiGetContactorsOptions()
            })
            .then(contactors => {
                this.setState({ contactorsOptionData: contactors }, () => console.log('contactorsOptionData', this.state.contactorsOptionData))

                // Load the user settings
                return apiCallsCommercial.apiUserSettings()
            })
            .then(userData => {
                this.setState({
                    userData: userData,
                    userId: userData.UserID,
                    wholesalerBranchID: userData.PreferredWholesaler1ItemID
                })

                // Load user favourite breakers
                return apiCallsResidential.apiGetUserFavouriteBreakers()
            })
            .then(favouriteBreakers => {
                this.setState({ favBreakers: favouriteBreakers })
                console.log('favouriteBreakers', favouriteBreakers)

                return apiCallsResidential.apiGetAllParts()
            })
            .then(allParts => {
                this.setState({
                    residentialAllPartsAvailable: allParts,
                    isLoading: false
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)

                // If there is an error during the loading state, then for now display it as an alert and redirect the user back to the project details
                if (this.state.isLoading) {
                    window.alert(error.message)
                    window.setTimeout(() => this.props.history.push(CONST.PAGES.PROJECT_DETAILS_RESIDENTIAL + '?orderID=' + this.state.projectID), 1000)
                }
            })
    }

    onScroll() {
        this.setState({ scrollTop: this.scrollRef.current.scrollTop })
    }

    startAddingBreaker() {
        this.setState({
            isBreakerModalOpen: true,
            editedBreaker: {
                idInCollection: null,
                isFav: false
            }
        })
    }

    startAddingAdditionalItems() {
        this.setState({ isAdditionalItemsModalOpen: true })
    }

    closeBreakerModal() {
        this.setState({ isBreakerModalOpen: false })
        commonFunctionsService.closeModals()
    }

    closeAddingAdditionalItemsModal() {
        this.setState({ isAdditionalItemsModalOpen: false })
    }

    startCreatingBusbar() {
        this.setState({ isBusbarModalOpen: true })
    }

    stopCreatingBusbar() {
        this.setState({ isBusbarModalOpen: false })
        commonFunctionsService.closeModals()
    }

    // Get the currently editing breaker
    getEditingBreaker() {
        if (!this.state.breakerOptionData || !this.state.editedBreaker.idInCollection) { return null }

        if (this.state.editedBreaker.isFav) {
            return this.state.favBreakers.find(item => item.ItemID === this.state.editedBreaker.idInCollection)
        } else {
            return this.state.board.ProjectBoardBreakerToolboxCollection.find(item => item.ItemID === this.state.editedBreaker.idInCollection)
        }
    }

    getBreaker(breakerID) {
        return this.state.board.ProjectBoardBreakerToolboxCollection.find(item => item.ItemID === breakerID)
    }

    getContactor(contactorItemId) {
        return this.state.board.ProjectBoardContactorToolboxCollection.find(item => item.ItemID === contactorItemId)
    }

    getFittedOption(fittedOptionItemId) {
        return this.state.board.ProjectBoardFittedOptionToolboxCollection.find(item => item.ItemID === fittedOptionItemId)
    }

    isBreakerFavourite(BreakerTypeItemID) {
        return this.state.favBreakers.find(item => item.BreakerTypeItemID === BreakerTypeItemID) !== undefined
    }

    getBreakerFavourite(BreakerTypeItemID) {
        return this.state.favBreakers.find(item => item.BreakerTypeItemID === BreakerTypeItemID)
    }

    addBreaker(breakerTypeId) {
        this.setState({ isLoading: true })

        apiCallsResidential.apiSaveBoardBreakerToolbox(this.state.projectID, this.state.boardID, breakerTypeId)
            .then(toolboxBreaker => {
                const updatedBreakers = cloneDeep(this.state.board.ProjectBoardBreakerToolboxCollection)
                const updatedBoard = cloneDeep(this.state.board)

                updatedBreakers.push(toolboxBreaker)
                updatedBoard.ProjectBoardBreakerToolboxCollection = updatedBreakers

                // Show tutorial once 1 breaker is added and only if Drag and Drop is enabled. And remember it, so we don't display it again to the user.
                if (window.localStorage.getItem('hasSeenTutorial') === null && updatedBreakers.length === 1 && this.state.isDragAndDropEnabled) {
                    this.setState({ showDragNDropTutorial: true })
                    window.setTimeout(() => this.setState({ showDragNDropTutorial: false }), 6000)
                    window.localStorage.setItem('hasSeenTutorial', 'true')
                }

                this.setState({ board: updatedBoard }, () => {
                    analyticsDataLayer.addBreaker({
                        "item_board_name": this.state.board.Name,
                        "item_board_id": this.state.boardID.toString(),
                        "configuration_name": this.state.board.Name,
                        "configuration_id": this.state.boardID.toString(),
                        "project_name": this.state.project.Title,
                        "project_id": this.state.projectID.toString(),
                        "project_type": 'Residential',
                        "funnel_step": '1',
                        "funnel_total_steps": '1'
                    })
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                this.closeBreakerModal()
                this.setState({ isLoading: false })
            })
    }

    saveContactor(itemID) {
        console.log('Should save saveContactor, item ID: ' + itemID)
        this.setState({ isLoading: true })

        apiCallsResidential.apiSaveBoardContactorToolbox(this.state.projectID, this.state.boardID, itemID)
            .then(toolboxContactor => {
                const updatedContactors = cloneDeep(this.state.board.ProjectBoardContactorToolboxCollection)
                const updatedBoard = cloneDeep(this.state.board)

                updatedContactors.push(toolboxContactor)
                updatedBoard.ProjectBoardContactorToolboxCollection = updatedContactors

                if (updatedContactors.length === 1) this.displayTutorial()

                this.setState({ board: updatedBoard })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                this.closeAddingAdditionalItemsModal()
                this.setState({ isLoading: false })
            })
    }

    saveFittedOption(itemID) {
        console.log('Should save saveFittedOption, item ID: ' + itemID)

        apiCallsResidential.apiSaveBoardFittedOptionToolbox(this.state.projectID, this.state.boardID, itemID)
            .then(toolboxFittedOption => {
                const updatedFittedOptions = cloneDeep(this.state.board.ProjectBoardFittedOptionToolboxCollection)
                const updatedBoard = cloneDeep(this.state.board)

                updatedFittedOptions.push(toolboxFittedOption)
                updatedBoard.ProjectBoardFittedOptionToolboxCollection = updatedFittedOptions

                if (updatedFittedOptions.length === 1) this.displayTutorial()

                this.setState({ board: updatedBoard })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                this.closeAddingAdditionalItemsModal()
                this.setState({ isLoading: false })
            })
    }

    displayTutorial() {
        // Show tutorial once 1 device is added and only if Drag and Drop is enabled. And remember it, so we don't display it again to the user.
        if (window.localStorage.getItem('hasSeenTutorial') === null && this.state.isDragAndDropEnabled) {
            this.setState({ showDragNDropTutorial: true })
            window.setTimeout(() => this.setState({ showDragNDropTutorial: false }), 6000)
            window.localStorage.setItem('hasSeenTutorial', 'true')
        }
    }

    handleDeletingBreaker(breakerID) {
        const breaker = this.getBreaker(breakerID)

        this.deleteBreaker(breakerID, breaker.BreakerTypeItemID)
    }

    deleteBreaker(breakerID, breakerTypeId) {
        this.setState({ isLoading: true })

        apiCallsResidential.apiSaveBoardBreakerToolbox(this.state.projectID, this.state.boardID, breakerTypeId, breakerID, true)
            .then((deletedBreaker) => {
                const updatedBreakers = this.state.board.ProjectBoardBreakerToolboxCollection.filter(item => item.ItemID !== breakerID)
                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardBreakerToolboxCollection = updatedBreakers

                this.setState({
                    board: updatedBoard,
                    editedBreaker: {
                        idInCollection: null,
                        isFav: false
                    }
                })

                analyticsDataLayer.removeFromCart({
                    "currency": 'AUD',
                    "value": deletedBreaker.Price,
                    "project_type": 'Residential',
                    "project_name": this.state.project.Title,
                    "project_id": this.state.projectID.toString(),
                    "item_board_name": this.state.board.Name,
                    "item_board_id": this.state.boardID.toString(),
                    "configuration_name": this.state.board.Name,
                    "configuration_id": this.state.boardID.toString(),          
                    "items": [
                        {
                            "item_id": deletedBreaker.BreakerTypeReadOnly.Reference,
                            "item_name": deletedBreaker.BreakerTypeReadOnly.Description, // MCB-10kA-1P-16A
                            "quantity": deletedBreaker?.BreakerTypeReadOnly?.SpaceUsed ? parseInt(deletedBreaker.BreakerTypeReadOnly.SpaceUsed) : 1,
                            "item_brand": 'FlexSelect',
                            "item_category": deletedBreaker.Category,
                            "item_variant": '',
                            "price": deletedBreaker.Price
                        }
                    ]
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => this.setState({ isLoading: false }))
    }

    handleDeletingContactor(contactorID) {
        const contactor = this.getContactor(contactorID)

        this.deleteContactor(contactorID, contactor.ContactorItemID)
    }

    handleDeletingFittedOption(fittedOptionID) {
        const fittedOption = this.getFittedOption(fittedOptionID)

        this.deleteFittedOption(fittedOptionID, fittedOption.FittedOptionItemID)
    }

    deleteContactor(contactorID, contactorItemId) {
        this.setState({ isLoading: true })

        apiCallsResidential.apiSaveBoardContactorToolbox(this.state.projectID, this.state.boardID, contactorItemId, contactorID, true)
            .then(() => {
                const updatedContactors = this.state.board.ProjectBoardContactorToolboxCollection.filter(item => item.ItemID !== contactorID)
                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardContactorToolboxCollection = updatedContactors

                this.setState({ board: updatedBoard })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => this.setState({ isLoading: false }))
    }

    deleteFittedOption(fittedOptionID, fittedOptionItemId) {
        this.setState({ isLoading: true })

        apiCallsResidential.apiSaveBoardFittedOptionToolbox(this.state.projectID, this.state.boardID, fittedOptionItemId, fittedOptionID, true)
            .then(() => {
                const updatedFittedOptions = this.state.board.ProjectBoardFittedOptionToolboxCollection.filter(item => item.ItemID !== fittedOptionID)
                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardFittedOptionToolboxCollection = updatedFittedOptions

                this.setState({ board: updatedBoard })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => this.setState({ isLoading: false }))
    }

    handleToggleBreakerFavourite(breakerID) {
        const breaker = this.getBreaker(breakerID)
        const favouriteBreaker = this.getBreakerFavourite(breaker.BreakerTypeItemID)
        const isBreakerFavourite = this.isBreakerFavourite(breaker.BreakerTypeItemID)

        var favouriteBreakerItemID = 0
        if (isBreakerFavourite) {
            favouriteBreakerItemID = favouriteBreaker.ItemID
        }

        this.toggleBreakerFavourite(favouriteBreakerItemID, breaker.BreakerTypeItemID, isBreakerFavourite)
    }

    toggleBreakerFavourite(ItemID, breakerTypeId, isBreakerFavourite) {
        this.setState({ isLoading: true })

        var favouriteItemID = 0
        if (isBreakerFavourite) favouriteItemID = ItemID

        apiCallsResidential.apiSaveFavBreaker(this.state.userId, breakerTypeId, favouriteItemID, isBreakerFavourite)
            .then(favBreaker => {
                let updatedBreakers = []
                if (isBreakerFavourite) {
                    updatedBreakers = this.state.favBreakers.filter(item => item.ItemID !== ItemID)
                } else {
                    updatedBreakers = cloneDeep(this.state.favBreakers)
                    updatedBreakers.push(favBreaker)
                }

                this.setState({ favBreakers: updatedBreakers })
                if (!isBreakerFavourite) {
                    let breakerItem = this.state.board.ProjectBoardBreakerToolboxCollection.find(res => res.BreakerTypeItemID === breakerTypeId)
                    analyticsDataLayer.addToFavourites({
                        "currency": 'AUD',
                        "project_type": 'Residential',
                        "project_name": this.state.project.Title,
                        "project_id": this.state.projectID.toString(),
                        "item_board_name": this.state.board.Name,
                        "item_board_id": this.state.boardID.toString(),
                        "configuration_name": this.state.board.Name,
                        "configuration_id": this.state.boardID.toString(), 
                        "value": breakerItem.Price,
                        "items": [{
                            "item_id": breakerItem.BreakerTypeReadOnly.Reference,
                            "item_name": breakerItem.BreakerTypeReadOnly.Description,
                            "item_brand": 'FlexSelect',
                            "item_category": breakerItem.Category,
                            "item_variant": '',
                            "price": breakerItem.Price,
                            "quantity": 1
                        }]
                    })
                } else {
                    analyticsDataLayer.removeFromFavourites({
                        "project_type": 'Residential',
                        "project_name": this.state.project.Title,
                        "project_id": this.state.projectID.toString(),
                        "item_board_name": this.state.board.Name,
                        "item_board_id": this.state.boardID
                    })
                }
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => this.setState({ isLoading: false }))
    }

    checkForDifferentProductRanges() {
        let has6kABreakers = false
        let has45kABreakers = false
        let hasMixedDifferentProductRanges = this.state.board.ProjectBoardBreakerCollection.some(breaker => {
            if (breaker.BreakerTypeReadOnly.TypeOfDevice.indexOf('4.5kA') > -1) has45kABreakers = true
            if (breaker.BreakerTypeReadOnly.TypeOfDevice.indexOf('6kA') > -1) has6kABreakers = true

            return has6kABreakers && has45kABreakers
        })

        this.setState({ hasMixedDifferentProductRanges: hasMixedDifferentProductRanges })
    }

    // ------------------------------
    // Chassis board functions
    // ------------------------------

    getChassisBoardBreakers() {
        if (!this.state.board.ProjectBoardBreakerCollection || !this.state.board.ProjectBoardBreakerCollection.length) { return [] }

        return this.state.board.ProjectBoardBreakerCollection.filter(boardBreaker => {
            const breakerObj = this.state.breakerOptionData.find(dataItem => dataItem.ItemID === boardBreaker.BreakerTypeItemID);
            return breakerObj
        });
    }

    // getDisabledIndex2ComponentName() {
    //     if (!this.state.board.ProjectBoardFittedOptionCollection || !this.state.board.ProjectBoardFittedOptionCollection.length) {
    //         return ''
    //     }

    //     const checkOption = this.state.board.ProjectBoardFittedOptionCollection.find(item => item.FittedOptionItemID === 2 || item.FittedOptionItemID === 3)

    //     if (checkOption === undefined) {
    //         return  ''
    //     } else {
    //         return checkOption.FittedOptionReadOnly.TypeDescription
    //     }
    // }

    // Get the number of poles already used up by breakers in a specific chassis
    getConfiguredPoleCount(chassisIndex) {
        let count = 0
        this.state.board.ProjectBoardBreakerCollection.forEach(boardBreaker => {
            const breakerObj = this.state.breakerOptionData.find(dataItem => dataItem.ItemID === boardBreaker.BreakerTypeItemID)
            if (breakerObj && boardBreaker.ChassisIndex === chassisIndex && !boardBreaker.BreakerIsParent) {
                count += breakerObj.PoleCount
            }
        })

        // For first chassis we need to check if position 2 is filled with emergency lighting
        if (chassisIndex === 1 && this.checkIfIndex2IsDisabled()) {
            count++
        }

        return count
    }

    // TODO: need to complete
    getChassisPercentComplete(chassisIndex) {
        // const boardData = this.getCurrentBoardData()
        // const total = boardData[`Chassis${chassisIndex}PoleCount`]
        // let doneCount = this.getConfiguredPoleCount(chassisIndex)
        // let notRoundedValue = doneCount / total * 100
        // let flooredValue = Math.floor(notRoundedValue)

        // if (notRoundedValue - flooredValue > 0.5) {
        //     return Math.ceil(notRoundedValue)
        // } else {
        //     return flooredValue
        // }

        return 0
    }

    getUsedCount(breakerObject) {
        if (!this.state.board.ProjectBoardBreakerCollection) { return 0 }

        return this.state.board.ProjectBoardBreakerCollection.filter(item => {
            return item.BreakerTypeItemID === breakerObject.ItemID
        }).length
    }

    getUsedContactorCount(contactorObject) {
        if (!this.state.board.ProjectBoardContractorCollection) { return 0 }

        return this.state.board.ProjectBoardContractorCollection.filter(item => {
            return item.ContractorItemID === contactorObject.ItemID
        }).length
    }

    getUsedFittedOptionCount(fittedOptionObject) {
        if (!this.state.board.ProjectBoardFittedOptionCollection) { return 0 }

        return this.state.board.ProjectBoardFittedOptionCollection.filter(item => {
            return item.FittedOptionItemID === fittedOptionObject.ItemID
        }).length
    }

    // Given the size of a device return the first row and pole index where it can be inserted on the board
    // If passed reverse parameter, then find the first position starting from the last row and last position
    findAvailablePositionForDevice(spaceUsed, reverse = false) {
        const numberOfRows = getNumberOfRowsFromPolesString(this.state.boardDetails.PolesNeeded)
        const numberOfPoles = getPolesCountFromPolesString(this.state.boardDetails.PolesNeeded)
        let positionFound = null

        // Start checking each row and position to see if we can add the breaker to it
        if (reverse) {
            for (let rowIndex = numberOfRows - 1; rowIndex >= 0; rowIndex--) {
                for (let poleIndex = numberOfPoles - 1; poleIndex > 0; poleIndex--) {
                    if (this.canAddDeviceToPosition(parseInt(spaceUsed, 10), rowIndex, poleIndex, false, false, undefined, undefined, undefined, true)) {
                        positionFound = {
                            rowIndex: rowIndex,
                            poleIndex: poleIndex
                        }
                        break
                    }
                }

                if (positionFound !== null) break
            }
        } else {
            for (let rowIndex = 0; rowIndex < numberOfRows; rowIndex++) {
                for (let poleIndex = 0; poleIndex < numberOfPoles; poleIndex++) {
                    if (this.canAddDeviceToPosition(parseInt(spaceUsed, 10), rowIndex, poleIndex)) {
                        positionFound = {
                            rowIndex: rowIndex,
                            poleIndex: poleIndex
                        }
                        break
                    }
                }

                if (positionFound !== null) break
            }
        }

        return positionFound
    }

    // Work out the first available board slot to add the specific breaker and then add the breaker to the board if
    // such a slot is found - this function is triggered when a breaker is triggered to be auto added
    autoAddbreaker(breakerId) {
        if (!breakerId || this.state.isAutoAdding) { return; }

        let selectedBreaker = this.state.board.ProjectBoardBreakerToolboxCollection.find(item => item.ItemID === breakerId)
        const numberOfRows = getNumberOfRowsFromPolesString(this.state.boardDetails.PolesNeeded)
        const numberOfPoles = getPolesCountFromPolesString(this.state.boardDetails.PolesNeeded)

        // Start checking each row and position to see if we can add the breaker to it
        let foundPositionAndAddingBreaker = false
        for (let rowIndex = 0; rowIndex < numberOfRows; rowIndex++) {
            for (let poleIndex = 0; poleIndex < numberOfPoles; poleIndex++) {
                if (this.canAddDeviceToPosition(parseInt(selectedBreaker.BreakerTypeReadOnly.SpaceUsed, 10), rowIndex, poleIndex)) {
                    console.log('Auto Placement: found a position to add a breaker at row ' + (rowIndex + 1) + ', column: ' + (poleIndex + 1))
                    this.addBreakerToBoard(rowIndex, poleIndex, selectedBreaker.BreakerTypeReadOnly)
                    foundPositionAndAddingBreaker = true
                    break
                }
            }

            if (foundPositionAndAddingBreaker) break
        }

        if (!foundPositionAndAddingBreaker) {
            this.setState({ apiError: 'There are no suitable position on the board to add this breaker.!', hasAlreadyShownEnoughQuoteInfo: true })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
        }
    }

    autoAddContactor(contactorId) {
        if (!contactorId || this.state.isAutoAdding) { return; }

        let selectedDevice = this.state.board.ProjectBoardContactorToolboxCollection.find(item => item.ItemID === contactorId)
        const numberOfRows = getNumberOfRowsFromPolesString(this.state.boardDetails.PolesNeeded)
        const numberOfPoles = getPolesCountFromPolesString(this.state.boardDetails.PolesNeeded)

        // Start checking each row and position to see if we can add the breaker to it
        let foundPositionAndAddingDevice = false
        for (let rowIndex = 0; rowIndex < numberOfRows; rowIndex++) {
            for (let poleIndex = 0; poleIndex < numberOfPoles; poleIndex++) {
                // Contactors can't go before the main switch
                if (rowIndex === 0 && poleIndex < parseInt(this.state.board.MainSwitchPosition, 10)) continue

                if (this.canAddDeviceToPosition(parseInt(selectedDevice.ContactorReadOnly.SpaceUsed, 10), rowIndex, poleIndex)) {
                    console.log('Auto Placement: found a position to add the contactor at row ' + (rowIndex + 1) + ', column: ' + (poleIndex + 1))
                    this.addContactorToBoard(rowIndex, poleIndex, selectedDevice.ContactorReadOnly)
                    foundPositionAndAddingDevice = true
                    break
                }
            }

            if (foundPositionAndAddingDevice) break
        }

        if (!foundPositionAndAddingDevice) {
            this.setState({ apiError: 'There are no suitable position on the board to add this contactor.!', hasAlreadyShownEnoughQuoteInfo: true })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
        }
    }

    autoAddFittedOption(fittedOptionId) {
        if (!fittedOptionId || this.state.isAutoAdding) { return; }

        let selectedDevice = this.state.board.ProjectBoardFittedOptionToolboxCollection.find(item => item.ItemID === fittedOptionId)
        const numberOfRows = getNumberOfRowsFromPolesString(this.state.boardDetails.PolesNeeded)
        const numberOfPoles = getPolesCountFromPolesString(this.state.boardDetails.PolesNeeded)

        // Start checking each row and position to see if we can add the breaker to it
        let foundPositionAndAddingDevice = false
        for (let rowIndex = 0; rowIndex < numberOfRows; rowIndex++) {
            for (let poleIndex = 0; poleIndex < numberOfPoles; poleIndex++) {
                if (this.canAddDeviceToPosition(parseInt(selectedDevice.FittedOptionReadOnly.SpaceUsed, 10), rowIndex, poleIndex)) {
                    console.log('Auto Placement: found a position to add the fitted option at row ' + (rowIndex + 1) + ', column: ' + (poleIndex + 1))
                    this.addFittedOptionToBoard(rowIndex, poleIndex, selectedDevice.FittedOptionReadOnly)
                    foundPositionAndAddingDevice = true
                    break
                }
            }

            if (foundPositionAndAddingDevice) break
        }

        if (!foundPositionAndAddingDevice) {
            this.setState({ apiError: 'There are no suitable position on the board to add this contactor.!', hasAlreadyShownEnoughQuoteInfo: true })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
        }
    }

    // Get the breaker data from the breaker type id
    getBreakerDataObj(breakerTypeId) {
        return this.state.breakerOptionData.find(item => item.ItemID === breakerTypeId)
    }

    canAddDeviceToPosition(speceUsed, rowIndex, poleIndex, returnErrorMessage, isMainSwitch, breakerItemID, boardContactorId, boardFittedOptionId, isWiserEnergyGateWay, ignoreBusbarChecks = false) {
        return canAddDeviceToBoardPosition(speceUsed, rowIndex, poleIndex, returnErrorMessage, this.state.board, this.state.boardDetails, this.state.boardOptionData, isMainSwitch, breakerItemID, boardContactorId, boardFittedOptionId, isWiserEnergyGateWay, ignoreBusbarChecks)
    }

    getMainSwitchDetails() {
        return this.state.boardOptionData.MainSwitches.find(mainSwitch => mainSwitch.ItemID === this.state.board.MainSwitchID)
    }

    addBreakerToBoard(rowIndex, poleIndex, breakerData, breakerItemID) {
        // Ignore the request if we are already adding breaker in this position
        if (this.state.isAddingDevice.indexOf(poleIndex) !== -1) return

        const canAddMessage = this.canAddDeviceToPosition(parseInt(breakerData.SpaceUsed, 10), rowIndex, poleIndex, true, false, breakerItemID)
        if (canAddMessage !== '') {
            this.setState({ apiError: canAddMessage })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return
        }

        // Check if the breaker can be added to the board considering the main incomer
        // If you have added a 1 phase main incomer - then you can only add 1 phase breakers to the board
        // If you have added a 1 phase main incomer - you still can add 36 mm 1P+N RCBO, because it's single phase even if it takes 2 spaces + other cases
        // If you have added a 2 phase main incomer - then you can only add 1 or 2 phase breaks to the board
        // If you have added a 3 phase main incomer - then you can add 1 or 2 or 3 or more phase breaks to the board
        const mainSwitchDetails = this.getMainSwitchDetails()
        const polesUsedByBreaker = parseInt(breakerData.SpaceUsed, 10)
        if (polesUsedByBreaker > mainSwitchDetails.SpaceUsed && mainSwitchDetails.SpaceUsed <= 2 &&
            // Special cases
            breakerData.NumberOfPoles !== '36 mm 1P+N' &&
            !(breakerData.TypeOfDevice === 'RCD-4.5kA' && breakerData.NumberOfPoles === '2P') &&
            !(breakerData.TypeOfDevice === 'RCD - 6kA' && breakerData.NumberOfPoles === '2P')
        ) {
            this.setState({ apiError: 'Breaker phase is not compatible with the board\'s main switch phase incomer.' })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return
        }

        // Update the state with the breakers position we are adding
        this.setState({ isAddingDevice: this.state.isAddingDevice.concat([poleIndex]) })


        const selectedBreakerData = breakerData ? breakerData : this.state.selectedBreaker.data
        // Here we are to improve the front-end performance when adding breakers. We don't want to display a loader each time and wait for a second or two
        // What we are going to do is to display a loader only when adding the very first breaker, once we have at least one breaker
        // We can use that as a sample object, reset it wrapping properties and add it immediatly locally, so it can be displayed on the board
        // Once the server response is ready we will override it or remove it if there were any errors

        let sampleBreaker = cloneDeep(SAMPLE_BREAKER)
        const updatedBreakers = cloneDeep(this.state.board.ProjectBoardBreakerCollection)
        const updatedProject = cloneDeep(this.state.project)
        const updatedBoard = cloneDeep(this.state.board)

        sampleBreaker.BreakerTypeReadOnly = selectedBreakerData
        // Reset Item ID, so we can use it as an indicator to disable delete button/drag&drop until the response from the server 
        // And to avoid some issues when user tries to do operations on this breakers before it's properly saved
        sampleBreaker.BreakerTypeItemID = selectedBreakerData.ItemID
        sampleBreaker.ItemID = 0
        // sampleBreaker.ChassisIndex = this.state.selectedChassisIndex
        sampleBreaker.PoleIndex = poleIndex
        sampleBreaker.RowIndex = rowIndex

        updatedBreakers.push(sampleBreaker)

        updatedBoard.ProjectBoardBreakerCollection = updatedBreakers
        this.setState({ project: updatedProject, board: updatedBoard })

        let self = this
        // self.selectedBr
        // TODO: For updating will need to replace 0 with existing breaker ItemID === do we even use this function to update a breker, doesn't look like?
        apiCallsResidential.apiSaveBreakerToChassis(this.state.projectID, this.state.boardID, 0, breakerData.ItemID, rowIndex, poleIndex)
            .then(boardBreaker => {

                const existingTemporaryBreakerIndex = this.state.board.ProjectBoardBreakerCollection.findIndex(item => item.BreakerTypeItemID === breakerData.ItemID && item.RowIndex === rowIndex && item.PoleIndex === poleIndex)


                // TODO: PROBABLY CAN IGNORE, IT OBVIOUSLY WON'T EXIST AS WE CALL IT TO ADD IT
                // Only need to add the breaker to the board if the board breaker doesnt exist on the board already
                // const existingBoardBreaker = this.state.board.ProjectBoardBreakerCollection.find(boardBreaker => boardBreaker.ItemID === breakerData.ItemID)

                const updatedBreakers = cloneDeep(this.state.board.ProjectBoardBreakerCollection)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)

                updatedBreakers[existingTemporaryBreakerIndex] = boardBreaker

                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers

                const boardCompletionDetails = BoardService.getBoardCompletionDetails(updatedBoard, this.state.boardDetails)
                this.setState({
                    boardPolesTotal: boardCompletionDetails.totalPoles,
                    boardPolesConfigured: boardCompletionDetails.totalPolesConfigured,
                    boardPolesRemaining: boardCompletionDetails.totalPolesRemaining,
                    boardCompletionPercentage: boardCompletionDetails.completionPercentage
                })

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
                    return board.ItemID === updatedBoard.ItemID
                })

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard }, () => {
                    if (this.isEnoughFilledToGenerateQuote() && !this.state.hasAlreadyShownEnoughQuoteInfo) {
                        this.setState({ pageInfo: 'You can now view a quote for this project!', hasAlreadyShownEnoughQuoteInfo: true })
                        window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
                    }

                    this.checkForDifferentProductRanges()
                })


                analyticsDataLayer.addToCart({
                    'project_type': 'Residential',
                    'project_name': this.state.project.Title,
                    'project_id': this.state.projectID.toString(),
                    'item_board_name': this.state.board.Name,
                    'item_board_id': this.state.boardID.toString(),
                    'configuration_name': this.state.board.Name,
                    'configuration_id': this.state.board.ItemID.toString()
                }, {
                    'currency': 'AUD',
                    'value': boardBreaker.Price,
                    'items': [
                        {
                            'item_id': boardBreaker.BreakerTypeReadOnly.Reference,
                            'item_name': boardBreaker.BreakerTypeReadOnly.Description, // MCB-10kA-1P-16A
                            'quantity': boardBreaker?.BreakerTypeReadOnly?.SpaceUsed ? parseInt(boardBreaker.BreakerTypeReadOnly.SpaceUsed) : 0,
                            'item_brand': 'FlexSelect',
                            'item_category': boardBreaker.Category,
                            'item_variant': '',
                            'price': boardBreaker.Price
                        }
                    ]
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
                // Remove the breaker from the board if there was an error
                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers.filter(item => item.ItemID !== 0)
                this.setState({ project: updatedProject, board: updatedBoard })
            })
            .then(() => {
                // Set state to indicate we are done adding
                this.setState({ isAddingDevice: this.state.isAddingDevice.filter(item => item !== poleIndex) })
            })
    }

    deleteBreakerFromBoard(rowIndex, poleIndex, boardBreakerId) {
        const selectedBoardBreaker = this.state.board.ProjectBoardBreakerCollection.find(boardBreaker => boardBreaker.ItemID === boardBreakerId)

        this.setState({ isUpdatingDevice: true })

        apiCallsResidential.apiSaveBreakerToChassis(this.state.projectID, this.state.boardID, boardBreakerId, selectedBoardBreaker.BreakerTypeItemID, rowIndex, poleIndex, true)
            .then((boardBreaker) => {
                const updatedBreakers = this.state.board.ProjectBoardBreakerCollection.filter(item => item.ItemID !== boardBreakerId)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers

                const boardCompletionDetails = BoardService.getBoardCompletionDetails(updatedBoard, this.state.boardDetails)
                this.setState({
                    boardPolesTotal: boardCompletionDetails.totalPoles,
                    boardPolesConfigured: boardCompletionDetails.totalPolesConfigured,
                    boardPolesRemaining: boardCompletionDetails.totalPolesRemaining,
                    boardCompletionPercentage: boardCompletionDetails.completionPercentage,
                })

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
                    return board.ItemID === updatedBoard.ItemID
                })

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard, pageInfo: 'Breaker deleted', isUpdatingDevice: false }, () => {
                    this.checkForDifferentProductRanges()
                })

                analyticsDataLayer.removeFromCart({
                    "currency": 'AUD',
                    "value": selectedBoardBreaker.Price,
                    "project_type": 'Residential',
                    "project_name": this.state.project.Title,
                    "project_id": this.state.projectID.toString(),
                    "item_board_name": this.state.board.Name,
                    "item_board_id": this.state.boardID.toString(),
                    "configuration_name": this.state.board.Name,
                    "configuration_id": this.state.boardID.toString(),    
                    "items": [
                        {
                            "item_id": selectedBoardBreaker.BreakerTypeReadOnly.Reference,
                            "item_name": selectedBoardBreaker.BreakerTypeReadOnly.Description,
                            "quantity": selectedBoardBreaker?.BreakerTypeReadOnly?.SpaceUsed ? parseInt(selectedBoardBreaker.BreakerTypeReadOnly.SpaceUsed) : 0,
                            "item_brand": 'FlexSelect',
                            "item_category": selectedBoardBreaker.Category,
                            "item_variant": '',
                            "price": selectedBoardBreaker.Price
                        }
                    ]
                })


                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message, isUpdatingDevice: false })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    deleteContactorFromBoard(rowIndex, poleIndex, boardContactorId) {
        const selectedBoardContactor = this.state.board.ProjectBoardContractorCollection.find(boardContactor => boardContactor.ItemID === boardContactorId)

        this.setState({ isUpdatingDevice: true })

        apiCallsResidential.apiSaveContactorToChassis(this.state.projectID, this.state.boardID, boardContactorId, selectedBoardContactor.ContractorItemID, rowIndex, poleIndex, true)
            .then(() => {
                const updatedContactors = this.state.board.ProjectBoardContractorCollection.filter(item => item.ItemID !== boardContactorId)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardContractorCollection = updatedContactors

                const boardCompletionDetails = BoardService.getBoardCompletionDetails(updatedBoard, this.state.boardDetails)
                this.setState({
                    boardPolesTotal: boardCompletionDetails.totalPoles,
                    boardPolesConfigured: boardCompletionDetails.totalPolesConfigured,
                    boardPolesRemaining: boardCompletionDetails.totalPolesRemaining,
                    boardCompletionPercentage: boardCompletionDetails.completionPercentage,
                })

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
                    return board.ItemID === updatedBoard.ItemID
                })

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard, pageInfo: 'Contactor deleted', isUpdatingDevice: false })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message, isUpdatingDevice: false })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    deleteFittedOptionFromBoard(rowIndex, poleIndex, boardFittedOptionId) {
        const selectedBoardFittedOption = this.state.board.ProjectBoardFittedOptionCollection.find(boardContactor => boardContactor.ItemID === boardFittedOptionId)

        this.setState({ isUpdatingDevice: true })

        apiCallsResidential.apiSaveFittedOptionToChassis(this.state.projectID, this.state.boardID, boardFittedOptionId, selectedBoardFittedOption.FittedOptionItemID, rowIndex, poleIndex, true)
            .then(() => {
                const updatedFittedOptions = this.state.board.ProjectBoardFittedOptionCollection.filter(item => item.ItemID !== boardFittedOptionId)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardFittedOptionCollection = updatedFittedOptions

                const boardCompletionDetails = BoardService.getBoardCompletionDetails(updatedBoard, this.state.boardDetails)
                this.setState({
                    boardPolesTotal: boardCompletionDetails.totalPoles,
                    boardPolesConfigured: boardCompletionDetails.totalPolesConfigured,
                    boardPolesRemaining: boardCompletionDetails.totalPolesRemaining,
                    boardCompletionPercentage: boardCompletionDetails.completionPercentage,
                })

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
                    return board.ItemID === updatedBoard.ItemID
                })

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard, pageInfo: 'Fitted option deleted', isUpdatingDevice: false }, () => {
                    this.handleWiserEnergyGatewayDisplay()
                })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message, isUpdatingDevice: false })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    canAddPowertag(returnErrorMessage, powerTagType) {
        // powerTagType can be 'breakerPowerTag' or 'fittedOptionPowerTag'
        // At this stage we support adding only 1 Wiser Energy Gateway, a second one will be automatically added as soon as user adds mora than 
        // 20 devices (powertags + A9XMC1D3 fitted option component) combined or more than 5 A9XMC1D3 components, but adding a second
        // is not supported
        let numberOfPowertags = 0
        let numberOfPowertagControls = 0 // A9XMC1D3, maximum 5 for one Wiser Energy Gateway
        let errorMessage = ''

        this.state.board.ProjectBoardBreakerCollection.forEach(breaker => {
            if (breaker.BottomPowerTag || breaker.TopPowerTag) numberOfPowertags = numberOfPowertags + 1
        })

        this.state.board.ProjectBoardFittedOptionCollection.forEach(fittedOption => {
            if (fittedOption.FittedOptionReadOnly.Reference === 'A9XMC1D3') numberOfPowertagControls = numberOfPowertagControls + 1
        })

        // So user is trying to see if he can add one of these, so we consider them and do our checks
        if (powerTagType === 'breakerPowerTag') numberOfPowertags = numberOfPowertags + 1
        if (powerTagType === 'fittedOptionPowerTag') numberOfPowertagControls = numberOfPowertagControls + 1

        if (numberOfPowertags + numberOfPowertagControls === 0) {
            // We don't have any power tags added, so if we add one, we need to assure we have a space for a mandatory and automatically
            // inserted Wiser Energy Gateway, which takes 2.5 poles on real board, but we consider it as 3 in our board. If there is no space
            // then we can't say that the power tag can be added
            const positionFound = this.findAvailablePositionForDevice(3, true)
            if (positionFound === null) {
                errorMessage = 'This action will required adding to the board a Wiser Energy Gateway, which occupies 2.5 poles. There was no spece found on the board, please free some space in order to proceed.'
            } else {
                console.log('Performed a check before adding a Powertag and a suitable position to place a mandatory Wiser Energy Gateway was found: ', positionFound)
            }
        } else if (numberOfPowertags + numberOfPowertagControls > 20) {
            errorMessage = 'The total number of Powertag components has reached the supported limit of 20. Can\'t add any more powertags.'
        } else if (numberOfPowertagControls > 5) {
            errorMessage = 'Can\'t add another Powertag control, the maximum limit supported is 5.'
        }

        if (returnErrorMessage) {
            return errorMessage
        } else {
            return errorMessage === ''
        }
    }

    // This function will check if it should display or not Wiser Energy Gateway and it will display it or not
    handleWiserEnergyGatewayDisplay() {
        let numberOfPowertags = 0
        let numberOfPowertagControls = 0

        this.state.board.ProjectBoardBreakerCollection.forEach(breaker => {
            if (breaker.BottomPowerTag || breaker.TopPowerTag) numberOfPowertags += 1
        })

        this.state.board.ProjectBoardFittedOptionCollection.forEach(fittedOption => {
            if (fittedOption.FittedOptionReadOnly.Reference === 'A9XMC1D3') numberOfPowertagControls += 1
        })

        if (numberOfPowertags + numberOfPowertagControls === 0) {
            if (this.state.board.HasWiserEnergyGateway === true) {
                // Here the condition mean that the board doesn't have any powertags (probably just removed the last one), and it has
                // Wiser Energy Gateway. We don't need it, so we need to save the information that board doesn't have it
                const boardRequest = {
                    Name: this.state.board.Name,
                    ProjectID: this.state.projectID,
                    EnclosureID: this.state.board.EnclosureID,
                    MainSwitchID: this.state.board.MainSwitchID,
                    SPDID: this.state.board.SPDID,
                    MetalBlackPlateID: this.state.board.MetalBlackPlateID,
                    Quantity: this.state.board.Quantity,
                    ItemID: this.state.board.ItemID,
                    MainSwitchPosition: this.state.board.MainSwitchPosition,
                    HasWiserEnergyGateway: false,
                    WiserEnergyGatewayPosition: 0,
                    WiserEnergyGatewayRow: 0
                }

                this.saveBoard(boardRequest)
            }
        } else {
            if (this.state.board.HasWiserEnergyGateway === false) {
                const positionFound = this.findAvailablePositionForDevice(3, true)
                console.log(this.state.board)
                if (positionFound === null) {
                    window.alert('Your action requires placing a Wiser Energy Gateway on the board, but no space was found to add it. Please, make space by removing some devices or increasing the size of the board')
                } else {
                    const boardRequest = {
                        Name: this.state.board.Name,
                        ProjectID: this.state.projectID,
                        EnclosureID: this.state.board.EnclosureID,
                        MainSwitchID: this.state.board.MainSwitchID,
                        SPDID: this.state.board.SPDID,
                        MetalBlackPlateID: this.state.board.MetalBlackPlateID,
                        Quantity: this.state.board.Quantity,
                        ItemID: this.state.board.ItemID,
                        MainSwitchPosition: this.state.board.MainSwitchPosition,
                        HasWiserEnergyGateway: true,
                        WiserEnergyGatewayPosition: positionFound.poleIndex,
                        WiserEnergyGatewayRow: positionFound.rowIndex
                    }

                    this.saveBoard(boardRequest)
                }
            }
        }
    }

    togglePowerTag(rowIndex, poleIndex, boardBreakerId, position, addPowerTag) {
        const selectedBoardBreaker = this.state.board.ProjectBoardBreakerCollection.find(boardBreaker => boardBreaker.ItemID === boardBreakerId)
        let topPowerTag = selectedBoardBreaker.TopPowerTag
        let bottomPowerTag = selectedBoardBreaker.BottomPowerTag

        if (position === 'top') topPowerTag = addPowerTag
        if (position === 'bottom') bottomPowerTag = addPowerTag

        // Check if we can add power tag, if we can then update selectedBoardBreaker inside the ProjectBoardBreakerCollection, even before API 
        // So user can have immediate visual feedback, otherwise display a massage that it can't be added 
        if (addPowerTag) { // Don't need to do check if user is actually removing a Power Tag
            const powertagCheck = this.canAddPowertag(true, 'breakerPowerTag')
            if (powertagCheck !== '') {
                // Display error message and don't continue
                this.setState({ apiError: powertagCheck })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
                return false
            }
        }

        if (position === 'top') selectedBoardBreaker.TopPowerTag = addPowerTag
        if (position === 'bottom') selectedBoardBreaker.BottomPowerTag = addPowerTag
        this.updateBreakerState(selectedBoardBreaker)


        this.setState({ isUpdatingDevice: true })

        apiCallsResidential.apiSaveBreakerToChassis(this.state.projectID, this.state.boardID, boardBreakerId, selectedBoardBreaker.BreakerTypeItemID, rowIndex, poleIndex, false, '', topPowerTag, bottomPowerTag)
            .then(boardBreaker => {
                this.updateBreakerState(boardBreaker)
                this.handleWiserEnergyGatewayDisplay()
                this.setState({ isUpdatingDevice: false })
            })
            .catch(error => {
                this.setState({ apiError: error.message, isUpdatingDevice: false })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    updateBreakerState(boardBreakerData) {
        const updatedBreakers = cloneDeep(this.state.board.ProjectBoardBreakerCollection)
        const updatedProject = cloneDeep(this.state.project)
        const updatedBoard = cloneDeep(this.state.board)

        const indexOfTheUpdatedBreaker = updatedBreakers.findIndex(breaker => {
            return breaker.ItemID === boardBreakerData.ItemID
        })

        updatedBreakers[indexOfTheUpdatedBreaker] = boardBreakerData
        updatedBoard.ProjectBoardBreakerCollection = updatedBreakers

        const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
            return board.ItemID === updatedBoard.ItemID
        })

        updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

        this.setState({ project: updatedProject, board: updatedBoard })
    }

    updateBrekerChassisNote(boardBreakerId, rowIndex, poleIndex, note) {
        const selectedBoardBreaker = this.state.board.ProjectBoardBreakerCollection.find(boardBreaker => boardBreaker.ItemID === boardBreakerId)
        let topPowerTag = selectedBoardBreaker.TopPowerTag
        let bottomPowerTag = selectedBoardBreaker.BottomPowerTag

        apiCallsResidential.apiSaveBreakerToChassis(this.state.projectID, this.state.boardID, boardBreakerId, selectedBoardBreaker.BreakerTypeItemID, rowIndex, poleIndex, false, note, topPowerTag, bottomPowerTag)
            .then(boardBreaker => {
                const updatedBreakers = this.state.board.ProjectBoardBreakerCollection.map(item => {
                    if (item.ItemID === boardBreaker.ItemID) {
                        return boardBreaker
                    } else {
                        return item
                    }
                })

                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers

                this.setState({ board: updatedBoard, pageInfo: 'Breaker notes saved' })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    updateContactorChassisNote(boardContactorId, rowIndex, poleIndex, note) {
        const selectedBoardContactor = this.state.board.ProjectBoardContractorCollection.find(boardBreaker => boardBreaker.ItemID === boardContactorId)

        apiCallsResidential.apiSaveContactorToChassis(this.state.projectID, this.state.boardID, boardContactorId, selectedBoardContactor.ContractorItemID, rowIndex, poleIndex, false, note)
            .then(boardContactor => {
                const updatedContactors = this.state.board.ProjectBoardContractorCollection.map(item => {
                    if (item.ItemID === boardContactor.ItemID) {
                        return boardContactor
                    } else {
                        return item
                    }
                })

                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardContractorCollection = updatedContactors

                this.setState({ board: updatedBoard, pageInfo: 'Device notes saved' })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    updateFittedOptionChassisNote(boardFittedOptionId, rowIndex, poleIndex, note) {
        const selectedBoardFittedOption = this.state.board.ProjectBoardFittedOptionCollection.find(boardBreaker => boardBreaker.ItemID === boardFittedOptionId)

        apiCallsResidential.apiSaveContactorToChassis(this.state.projectID, this.state.boardID, boardFittedOptionId, selectedBoardFittedOption.FittedOptionItemID, rowIndex, poleIndex, false, note)
            .then(boardContactor => {
                const updatedFittedOptios = this.state.board.ProjectBoardFittedOptionCollection.map(item => {
                    if (item.ItemID === boardContactor.ItemID) {
                        return boardContactor
                    } else {
                        return item
                    }
                })

                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardFittedOptionCollection = updatedFittedOptios

                this.setState({ board: updatedBoard, pageInfo: 'Device notes saved' })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    updateBreakerPosition(boardBreakerId, rowIndex, poleIndex, note, skipChecks = false) {
        const selectedBoardBreaker = this.state.board.ProjectBoardBreakerCollection.find(boardBreaker => boardBreaker.ItemID === boardBreakerId)
        let topPowerTag = selectedBoardBreaker.TopPowerTag
        let bottomPowerTag = selectedBoardBreaker.BottomPowerTag

        if (!skipChecks) {
            const canAddMessage = this.canAddDeviceToPosition(parseInt(selectedBoardBreaker.BreakerTypeReadOnly.SpaceUsed, 10), rowIndex, poleIndex, true, false, boardBreakerId)
            if (canAddMessage !== '') {
                this.setState({ apiError: canAddMessage })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)

                return
            }
        }

        this.setState({ isAddingDevice: this.state.isAddingDevice.concat([poleIndex]) })

        apiCallsResidential.apiSaveBreakerToChassis(this.state.projectID, this.state.boardID, boardBreakerId, selectedBoardBreaker.BreakerTypeItemID, rowIndex, poleIndex, false, note, topPowerTag, bottomPowerTag)
            .then(boardBreaker => {
                const updatedBreakers = this.state.board.ProjectBoardBreakerCollection.map(item => {
                    if (item.ItemID === boardBreaker.ItemID) {
                        return boardBreaker
                    } else {
                        return item
                    }
                })

                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers

                this.setState({ board: updatedBoard, pageInfo: 'Breaker notes saved' })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                // Set state to indicate we are done adding
                this.setState({ isAddingDevice: this.state.isAddingDevice.filter(item => item !== poleIndex) })
            })
    }

    updateContactorPosition(boardContactorId, rowIndex, poleIndex, note, skipChecks = false) {
        const selectedBoardContactor = this.state.board.ProjectBoardContractorCollection.find(boardContactor => boardContactor.ItemID === boardContactorId)

        if (!skipChecks) {
            const canAddMessage = this.canAddDeviceToPosition(parseInt(selectedBoardContactor.ContractorReadOnly.SpaceUsed, 10), rowIndex, poleIndex, true, false, undefined, boardContactorId)
            if (canAddMessage !== '') {
                this.setState({ apiError: canAddMessage })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)

                return
            }
        }

        this.setState({ isAddingDevice: this.state.isAddingDevice.concat([poleIndex]) })

        apiCallsResidential.apiSaveContactorToChassis(this.state.projectID, this.state.boardID, boardContactorId, selectedBoardContactor.ContractorItemID, rowIndex, poleIndex, false, note)
            .then(boardContactor => {
                const updatedBreakers = this.state.board.ProjectBoardContractorCollection.map(item => {
                    if (item.ItemID === boardContactor.ItemID) {
                        return boardContactor
                    } else {
                        return item
                    }
                })

                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardContractorCollection = updatedBreakers

                this.setState({ board: updatedBoard, pageInfo: 'Device position saved' })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                // Set state to indicate we are done adding
                this.setState({ isAddingDevice: this.state.isAddingDevice.filter(item => item !== poleIndex) })
            })
    }

    updateFittedOptionPosition(boardFittedOptionId, rowIndex, poleIndex, note, skipChecks = false) {
        const selectedBoardFittedOption = this.state.board.ProjectBoardFittedOptionCollection.find(boardContactor => boardContactor.ItemID === boardFittedOptionId)

        if (!skipChecks) {
            const canAddMessage = this.canAddDeviceToPosition(parseInt(selectedBoardFittedOption.FittedOptionReadOnly.SpaceUsed, 10), rowIndex, poleIndex, true, false, undefined, undefined, boardFittedOptionId)
            if (canAddMessage !== '') {
                this.setState({ apiError: canAddMessage })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)

                return
            }
        }

        this.setState({ isAddingDevice: this.state.isAddingDevice.concat([poleIndex]) })

        apiCallsResidential.apiSaveFittedOptionToChassis(this.state.projectID, this.state.boardID, boardFittedOptionId, selectedBoardFittedOption.FittedOptionItemID, rowIndex, poleIndex, false, note)
            .then(boardFittedOption => {
                const updatedBreakers = this.state.board.ProjectBoardFittedOptionCollection.map(item => {
                    if (item.ItemID === boardFittedOption.ItemID) {
                        return boardFittedOption
                    } else {
                        return item
                    }
                })

                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardFittedOptionCollection = updatedBreakers

                this.setState({ board: updatedBoard, pageInfo: 'Device position saved' })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                // Set state to indicate we are done adding
                this.setState({ isAddingDevice: this.state.isAddingDevice.filter(item => item !== poleIndex) })
            })
    }

    updateMainSwitchPosition(poleIndex) {
        const boardRequest = {
            Name: this.state.board.Name,
            ProjectID: this.state.projectID,
            EnclosureID: this.state.board.EnclosureID,
            MainSwitchID: this.state.board.MainSwitchID,
            SPDID: this.state.board.SPDID,
            MetalBlackPlateID: this.state.board.MetalBlackPlateID,
            Quantity: this.state.board.Quantity,
            ItemID: this.state.board.ItemID,
            MainSwitchPosition: parseInt(poleIndex, 10),
            HasWiserEnergyGateway: this.state.board.HasWiserEnergyGateway,
            WiserEnergyGatewayPosition: this.state.board.WiserEnergyGatewayPosition,
            WiserEnergyGatewayRow: this.state.board.WiserEnergyGatewayRow
        }

        this.saveBoard(boardRequest)
    }

    updateWiserEnergyGatewayPosition(rowIndex, poleIndex) {
        const boardRequest = {
            Name: this.state.board.Name,
            ProjectID: this.state.projectID,
            EnclosureID: this.state.board.EnclosureID,
            MainSwitchID: this.state.board.MainSwitchID,
            SPDID: this.state.board.SPDID,
            MetalBlackPlateID: this.state.board.MetalBlackPlateID,
            Quantity: this.state.board.Quantity,
            ItemID: this.state.board.ItemID,
            MainSwitchPosition: this.state.board.MainSwitchPosition,
            HasWiserEnergyGateway: this.state.board.HasWiserEnergyGateway,
            WiserEnergyGatewayPosition: poleIndex,
            WiserEnergyGatewayRow: rowIndex
        }

        this.saveBoard(boardRequest)
    }

    saveBoard(boardRequest) {
        this.setState({ isLoading: true })

        apiCallsResidential.apiSaveBoard(boardRequest)
            .then(boardData => {
                this.setState({ board: boardData })
            })
            .catch(error => {
                this.setState({ isLoading: false })
                window.alert(`There was an error saving the board: ${error.message}`)
            })
            .then(() => {
                this.setState({ isLoading: false })
            })
    }

    removeBusbar(itemID, BusBarItemID) {
        this.setState({ isLoading: true })

        apiCallsResidential.apiSaveBusBar(this.state.projectID, this.state.boardID, itemID, BusBarItemID, 0, 0, 0, 0, true)
            .then(() => {
                const updatedBusbars = cloneDeep(this.state.board.ProjectBoardBusbarCollection)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)

                updatedBoard.ProjectBoardBusbarCollection = updatedBusbars.filter(busbar => busbar.ItemID !== itemID)

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex(board => board.ItemID === updatedBoard.ItemID)

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard }, () => {
                    console.log(this.state.project)
                    this.setState({ pageInfo: 'Busbar removed from the board!' })
                    window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                this.setState({ isLoading: false })
            })
    }

    handleBreakerDrop(rowIndex, poleIndex, ItemID, BreakerTypeItemID) {
        let selectedBreaker = this.state.board.ProjectBoardBreakerToolboxCollection.find(item => item.ItemID === ItemID)
        const useBreaker = this.state.breakerOptionData.find(item => selectedBreaker ? item.ItemID === selectedBreaker.BreakerTypeItemID : false)

        this.addBreakerToBoard(rowIndex, poleIndex, useBreaker, ItemID)
    }

    handleContactorDrop(rowIndex, poleIndex, ItemID, ContactorItemID) {
        let selectedContactor = this.state.board.ProjectBoardContactorToolboxCollection.find(item => item.ItemID === ItemID)
        this.addContactorToBoard(rowIndex, poleIndex, selectedContactor.ContactorReadOnly)
    }

    handleFittedOptionDrop(rowIndex, poleIndex, ItemID, FittedOptionItemID) {
        let selectedFittedOption = this.state.board.ProjectBoardFittedOptionToolboxCollection.find(item => item.ItemID === ItemID)
        this.addFittedOptionToBoard(rowIndex, poleIndex, selectedFittedOption.FittedOptionReadOnly)
    }

    addContactorToBoard(rowIndex, poleIndex, contactorData) {
        // Ignore the request if we are already adding device in this position
        if (this.state.isAddingDevice.indexOf(poleIndex) !== -1) return
        const canAddMessage = this.canAddDeviceToPosition(parseInt(contactorData.SpaceUsed, 10), rowIndex, poleIndex, true, false, null, contactorData.ItemID, null, false, false)
        if (canAddMessage !== '') {
            this.setState({ apiError: canAddMessage })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return
        }

        // Contactors can't be placed before the main switch
        if (rowIndex === 0 && poleIndex < parseInt(this.state.board.MainSwitchPosition, 10)) {
            this.setState({ apiError: 'Contactors can\'t be added before the main switch.' })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return
        }

        // Update the state with the breakers position we are adding
        this.setState({ isAddingDevice: this.state.isAddingDevice.concat([poleIndex]) })

        const selectedContactorData = contactorData ? contactorData : this.state.selectedContactor.data
        // Here we are to improve the front-end performance when adding breakers. We don't want to display a loader each time and wait for a second or two
        // What we are going to do is to display a loader only when adding the very first breaker, once we have at least one breaker
        // We can use that as a sample object, reset it wrapping properties and add it immediatly locally, so it can be displayed on the board
        // Once the server response is ready we will override it or remove it if there were any errors

        let sampleContactors = cloneDeep(SAMPLE_CONTRACTOR)
        const updatedContactors = cloneDeep(this.state.board.ProjectBoardContractorCollection)
        const updatedProject = cloneDeep(this.state.project)
        const updatedBoard = cloneDeep(this.state.board)

        sampleContactors.ContractorReadOnly = selectedContactorData
        // Reset Item ID, so we can use it as an indicator to disable delete button/drag&drop until the response from the server 
        // And to avoid some issues when user tries to do operations on this breakers before it's properly saved
        sampleContactors.ItemID = 0
        sampleContactors.ContractorItemID = selectedContactorData.ItemID
        // sampleContactors.ChassisIndex = this.state.selectedChassisIndex
        sampleContactors.PoleIndex = poleIndex
        sampleContactors.RowIndex = rowIndex

        updatedContactors.push(sampleContactors)

        updatedBoard.ProjectBoardContractorCollection = updatedContactors
        this.setState({ project: updatedProject, board: updatedBoard })

        apiCallsResidential.apiSaveContactorToChassis(this.state.projectID, this.state.boardID, 0, contactorData.ItemID, rowIndex, poleIndex)
            .then(boardContactor => {

                const existingTemporaryContactorIndex = this.state.board.ProjectBoardContractorCollection.findIndex(item => item.ContractorItemID === contactorData.ItemID && item.RowIndex === rowIndex && item.PoleIndex === poleIndex)
                console.log('existingTemporaryContactorIndex', existingTemporaryContactorIndex)

                const updatedContactors = cloneDeep(this.state.board.ProjectBoardContractorCollection)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)

                // updatedContactors.push(boardContactor)
                updatedContactors[existingTemporaryContactorIndex] = boardContactor

                updatedBoard.ProjectBoardContractorCollection = updatedContactors

                const boardCompletionDetails = BoardService.getBoardCompletionDetails(updatedBoard, this.state.boardDetails)
                this.setState({
                    boardPolesTotal: boardCompletionDetails.totalPoles,
                    boardPolesConfigured: boardCompletionDetails.totalPolesConfigured,
                    boardPolesRemaining: boardCompletionDetails.totalPolesRemaining,
                    boardCompletionPercentage: boardCompletionDetails.completionPercentage
                })

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
                    return board.ItemID === updatedBoard.ItemID
                })

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard }, () => {
                    if (this.isEnoughFilledToGenerateQuote() && !this.state.hasAlreadyShownEnoughQuoteInfo) {
                        this.setState({ pageInfo: 'You can now view a quote for this project!', hasAlreadyShownEnoughQuoteInfo: true })
                        window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
                    }
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
                // Remove the Contactor from the board if there was an error
                updatedBoard.ProjectBoardContractorCollection = updatedContactors.filter(item => item.ItemID !== 0)
                this.setState({ project: updatedProject, board: updatedBoard })
            })
            .then(() => {
                // Set state to indicate we are done adding
                this.setState({ isAddingDevice: this.state.isAddingDevice.filter(item => item !== poleIndex) })
            })
    }

    addFittedOptionToBoard(rowIndex, poleIndex, fittedOptionData) {
        // Ignore the request if we are already adding device in this position
        if (this.state.isAddingDevice.indexOf(poleIndex) !== -1) return
        const canAddMessage = this.canAddDeviceToPosition(parseInt(fittedOptionData.SpaceUsed, 10), rowIndex, poleIndex, true, false, null, null, fittedOptionData.ItemID, false, false)
        if (canAddMessage !== '') {
            this.setState({ apiError: canAddMessage })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return
        }

        // If it is a powertag, then performe checks
        if (fittedOptionData.Reference === 'A9XMC1D3') {
            const powertagCheck = this.canAddPowertag(true, 'fittedOptionPowerTag')
            if (powertagCheck !== '') {
                // Display error message and don't continue
                this.setState({ apiError: powertagCheck })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
                return false
            }
        }

        // Update the state with the breakers position we are adding
        this.setState({ isAddingDevice: this.state.isAddingDevice.concat([poleIndex]) })

        const selectedFittedOptionData = fittedOptionData ? fittedOptionData : this.state.selectedContactor.data
        // Here we are to improve the front-end performance when adding breakers. We don't want to display a loader each time and wait for a second or two
        // What we are going to do is to display a loader only when adding the very first breaker, once we have at least one breaker
        // We can use that as a sample object, reset it wrapping properties and add it immediatly locally, so it can be displayed on the board
        // Once the server response is ready we will override it or remove it if there were any errors

        let sampleFittedOption = cloneDeep(SAMPLE_FITTED_OPTION)
        const updatedFittedOption = cloneDeep(this.state.board.ProjectBoardFittedOptionCollection)
        const updatedProject = cloneDeep(this.state.project)
        const updatedBoard = cloneDeep(this.state.board)

        sampleFittedOption.FittedOptionReadOnly = selectedFittedOptionData
        // Reset Item ID, so we can use it as an indicator to disable delete button/drag&drop until the response from the server 
        // And to avoid some issues when user tries to do operations on this breakers before it's properly saved
        sampleFittedOption.ItemID = 0
        sampleFittedOption.FittedOptionItemID = selectedFittedOptionData.ItemID
        // sampleContactors.ChassisIndex = this.state.selectedChassisIndex
        sampleFittedOption.PoleIndex = poleIndex
        sampleFittedOption.RowIndex = rowIndex

        updatedFittedOption.push(sampleFittedOption)

        updatedBoard.ProjectBoardFittedOptionCollection = updatedFittedOption
        this.setState({ project: updatedProject, board: updatedBoard })

        apiCallsResidential.apiSaveFittedOptionToChassis(this.state.projectID, this.state.boardID, 0, fittedOptionData.ItemID, rowIndex, poleIndex)
            .then(boardFittedOption => {

                const existingTemporaryFittedOptionIndex = this.state.board.ProjectBoardFittedOptionCollection.findIndex(item => item.FittedOptionItemID === fittedOptionData.ItemID && item.RowIndex === rowIndex && item.PoleIndex === poleIndex)
                console.log('existingTemporaryFittedOptionIndex', existingTemporaryFittedOptionIndex)

                const updatedFittedOptions = cloneDeep(this.state.board.ProjectBoardFittedOptionCollection)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)

                updatedFittedOptions[existingTemporaryFittedOptionIndex] = boardFittedOption

                updatedBoard.ProjectBoardFittedOptionCollection = updatedFittedOptions

                const boardCompletionDetails = BoardService.getBoardCompletionDetails(updatedBoard, this.state.boardDetails)
                this.setState({
                    boardPolesTotal: boardCompletionDetails.totalPoles,
                    boardPolesConfigured: boardCompletionDetails.totalPolesConfigured,
                    boardPolesRemaining: boardCompletionDetails.totalPolesRemaining,
                    boardCompletionPercentage: boardCompletionDetails.completionPercentage
                })

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
                    return board.ItemID === updatedBoard.ItemID
                })

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard }, () => {
                    this.handleWiserEnergyGatewayDisplay()

                    if (this.isEnoughFilledToGenerateQuote() && !this.state.hasAlreadyShownEnoughQuoteInfo) {
                        this.setState({ pageInfo: 'You can now view a quote for this project!', hasAlreadyShownEnoughQuoteInfo: true })
                        window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
                    }
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)

                // Remove the FittedOption from the board if there was an error
                updatedBoard.ProjectBoardFittedOptionCollection = updatedFittedOption.filter(item => item.ItemID !== 0)
                this.setState({ project: updatedProject, board: updatedBoard })
            })
            .then(() => {
                // Set state to indicate we are done adding
                this.setState({ isAddingDevice: this.state.isAddingDevice.filter(item => item !== poleIndex) })
            })
    }

    addBusBarToBoard(busBarItemID, row, extraPoles, startPosition, busbarLength) {
        this.setState({ isAddingBusBar: true })

        apiCallsResidential.apiSaveBusBar(this.state.projectID, this.state.boardID, 0, busBarItemID, row, extraPoles, startPosition, busbarLength, false)
            .then(response => {
                const updatedBusbars = cloneDeep(this.state.board.ProjectBoardBusbarCollection)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)

                updatedBusbars.push(response)
                updatedBoard.ProjectBoardBusbarCollection = updatedBusbars

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex(board => board.ItemID === updatedBoard.ItemID)

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard }, () => {
                    this.setState({ pageInfo: 'Busbar added to the board!', isBusbarModalOpen: false })
                    window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                this.setState({ isAddingBusBar: false })
            })
    }

    hasMaxBoardLimitBeenReached() {
        // Function to check if the user has reached max board limit or not
        // App should not let user copy or add boards if they are at the limit.
        // Hardcode the max board limit if its not returned from the API
        const boardLimit = this.state.project.MaxBoardLimit ? this.state.project.MaxBoardLimit : 8
        return (this.state.project.ProjectBoards.length >= boardLimit)
    }

    addNewBoard() {
        this.props.history.push(CONST.PAGES.PROJECT_DETAILS_RESIDENTIAL + '?orderID=' + this.state.projectID + '&newBoard=true')
    }

    startConfiguringBoard() {
        this.setState({ isConfiguringBoard: true, boardToConfigure: this.state.board })
    }

    stopConfiguringBoard = (board) => {
        this.setState({
            projectID: getUrlParameter('projectID'),
            boardID: getUrlParameter('boardID')
        }, () => {
            this.initialize()

            // Give somes time for the board to re-initialize items based on new configuration
            window.setTimeout(() => {
                this.setState({ isConfiguringBoard: false, boardToConfigure: null })
                commonFunctionsService.closeModals()
            }, 2000)
        })
    }

    viewQuote() {
        let areEnoughBoardsToGenerateQuote = this.areEnoughBoardsToGenerateQuote()
        if (!areEnoughBoardsToGenerateQuote) {
            this.setState({ apiError: 'Board quantity is not enough to generate a quote.' })
            return false
        }

        // You've got boards but not all of them are filled out to minimum levels...
        let noEnoughFilled = !this.isEnoughFilledToGenerateQuote()
        if (noEnoughFilled) {
            this.setState({ apiError: 'Your project needs all boards filled with at least 4 breakers to generate a quote.' })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return false
        }

        // If you're a contractor you need a selected wholesaler
        if (this.state.userData.UserIsContractor && (this.state.wholesalerBranchID === 0 || this.state.wholesalerBranchID === -1)) {
            this.setState({ apiError: 'Current user doesn\'t have a preferred wholesalers configured.' })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return false
        }

        // Finally made it through all the hoops, go to the Quote page.
        let pageLink = ''
        if (this.state.userData.UserIsContractor) {
            pageLink += CONST.PAGES.QUOTE_RESIDENTIAL + '?projectID=' + this.state.projectID + '&wholesalerBranchID=' + this.state.wholesalerBranchID
            this.props.history.push(pageLink)
        } else {
            pageLink += CONST.PAGES.QUOTE_RESIDENTIAL + '?projectID=' + this.state.projectID
            this.props.history.push(pageLink)
        }

        analyticsDataLayer.ctaButtonClick({
            cta_name: 'View Quote',
            cta_link: window.location.hostname + pageLink,
            cta_location: 'Config board'
        })
    }

    isEnoughFilledToGenerateQuote() {
        // Let's work with assumption all boards are all enough filled and invalidate this indicator as soon as any board is not enough filled
        let areAllProjectBoardsEnoughFilled = true

        this.state.project.ProjectBoards.map(board => {
            const boardDetails = BoardService.getDetails(this.state.boardOptionData, board.EnclosureID, board.MainSwitchID, board.SPDID, board.MetalBlackPlateID)
            const boardCompletionDetails = BoardService.getBoardCompletionDetails(board, boardDetails)

            if (!boardCompletionDetails.isEnoughCompletedToSeeTheQuote) areAllProjectBoardsEnoughFilled = false
        })

        return areAllProjectBoardsEnoughFilled
    }

    areEnoughBoardsToGenerateQuote = () => {
        let totalUserBoardsQuantity = 0
        this.state.project.ProjectBoards.map(board => {
            totalUserBoardsQuantity = totalUserBoardsQuantity + board.Quantity
        })

        return totalUserBoardsQuantity >= CONST.MINIMUM_RESIDENTIAL_BOARD_QUANTITY ? true : false
    }

    getValidationMessage(item) {
        let validationMessage = ''
        if (!item?.IsInStock) {
            validationMessage = `${item.Description} is out of stock. Please, contact <a href="mailto:au.estimating@se.com">au.estimating@se.com</a>`
        } else if (item?.IsLowStock) {
            validationMessage = 'Low stock, longer lead times may apply'
        } else {
            validationMessage = ''
        }
        return validationMessage
    }

    handleUpdateQuantity(qty, id) {
        const updatedBoard = cloneDeep(this.state.board)
        updatedBoard.ProjectBoardBreakerToolboxCollection = updatedBoard.ProjectBoardBreakerToolboxCollection.map(item => {
            if (item.ItemID === id) {
                item.quantity = qty
            }
            return item
        })

        this.setState({ board: updatedBoard })
    }

    handleContactorUpdateQuantity(qty, id) {
        const updatedBoard = cloneDeep(this.state.board)
        updatedBoard.ProjectBoardContactorToolboxCollection = updatedBoard.ProjectBoardContactorToolboxCollection.map(item => {
            if (item.ItemID === id) {
                item.quantity = qty
            }
            return item
        })

        this.setState({ board: updatedBoard })
    }

    handleFittedOptionUpdateQuantity(qty, id) {
        const updatedBoard = cloneDeep(this.state.board)
        updatedBoard.ProjectBoardFittedOptionToolboxCollection = updatedBoard.ProjectBoardFittedOptionToolboxCollection.map(item => {
            if (item.ItemID === id) {
                item.quantity = qty
            }
            return item
        })

        this.setState({ board: updatedBoard })
    }

    render() {
        const breaker = this.state.board.ProjectBoardBreakerCollection?.filter(item => item.ItemID).length
        const contractor = this.state.board.ProjectBoardContractorCollection?.filter(item => item.ItemID).length
        const fittedOption = this.state.board.ProjectBoardFittedOptionCollection?.filter(item => item.ItemID).length
        const totalComponent = breaker + contractor + fittedOption

        if (this.state.isLoading) {
            return (
                <GlobalOverlay>
                    <div>
                        <div className="globalOverlay__message">
                            <span className="globalOverlay__message-spinner">
                                <span className="spinner"></span>
                            </span>
                            <span className="h3">Loading</span>
                        </div>
                    </div>
                </GlobalOverlay>
            )
        }

        if (this.state.isAddingDevice.length > 0 && totalComponent === 0) {
            return (
                <GlobalOverlay>
                    <div>
                        <div className="globalOverlay__message">
                            <span className="globalOverlay__message-spinner">
                                <span className="spinner"></span>
                            </span>
                            <span className="h3">Saving Device</span>
                        </div>
                    </div>
                </GlobalOverlay>
            )
        }

        if (this.state.isAddingBusBar) {
            return (
                <GlobalOverlay>
                    <div>
                        <div className="globalOverlay__message">
                            <span className="globalOverlay__message-spinner">
                                <span className="spinner"></span>
                            </span>
                            <span className="h3">Saving Busbar</span>
                        </div>
                    </div>
                </GlobalOverlay>
            )
        }

        return (
            <div className="app">
                {
                    this.state.showDragNDropTutorial &&
                    <GlobalOverlay>
                        <Player autoplay src="https://assets6.lottiefiles.com/packages/lf20_krirt85t.json"></Player>
                    </GlobalOverlay>
                }

                {
                    this.state.isBreakerModalOpen &&
                    <Modal
                        modalClassName=""
                        modalTitle={this.getEditingBreaker() ? 'Edit Breaker' : 'Add Breaker'}
                        callback={() => this.closeBreakerModal()}>

                        <BreakerDetailsFormContainerResidential
                            breaker={this.getEditingBreaker()}
                            breakerOptions={this.state.breakerOptions}
                            breakerOptionData={this.state.breakerOptionData}
                            incomerPhase={this.state.boardDetails.IncomerPhase}
                            createCallback={this.addBreaker}
                            residentialAllPartsAvailable={this.state.residentialAllPartsAvailable}
                        />
                    </Modal>
                }

                {
                    this.state.isAdditionalItemsModalOpen &&
                    <Modal
                        modalClassName=""
                        modalTitle={'Add additional Items'}
                        callback={() => this.closeAddingAdditionalItemsModal()}>

                        <AdditionalItemsFormContainer
                            contactors={this.state.contactorsOptionData}
                            fittedOptions={this.state.fittedOptions}
                            saveContactor={this.saveContactor}
                            saveFittedOption={this.saveFittedOption}
                            createCallback={this.addBreaker}
                            residentialAllPartsAvailable={this.state.residentialAllPartsAvailable}
                        />
                    </Modal>
                }

                {
                    this.state.isBusbarModalOpen &&
                    <Modal
                        modalID="add-busbar-modal"
                        modalClassName="add-busbar-modal modal"
                        modalTitle="Add Busbar"
                        callback={() => this.stopCreatingBusbar()}>

                        <BusBarFormContainer
                            polesNeeded={this.state.boardDetails.PolesNeeded}
                            incomerPhase={this.state.boardDetails.IncomerPhase}
                            mainSwitchID={this.state.board.MainSwitchID}
                            boardOptionData={this.state.boardOptionData}
                            breakersAttachedToTheBoard={this.state.board.ProjectBoardBreakerCollection}
                            contactorsAttachedToTheBoard={this.state.board.ProjectBoardContractorCollection}
                            fittedOptionsAttachedToTheBoard={this.state.board.ProjectBoardFittedOptionCollection}
                            busbarsData={this.state.busbarsData}
                            existingBusbars={this.state.board.ProjectBoardBusbarCollection}

                            addBusBarToBoard={(busBarItemID, row, extraPoles, startPosition, busbarLength) => {
                                this.addBusBarToBoard(busBarItemID, row, extraPoles, startPosition, busbarLength)
                            }}

                            board={this.state.board}
                            boardDetails={this.state.boardDetails}
                            boardOptions={this.state.boardOptions}

                            updateBreakerPosition={this.updateBreakerPosition}
                            updateContactorPosition={this.updateContactorPosition}
                            updateFittedOptionPosition={this.updateFittedOptionPosition}
                            updateMainSwitchPosition={this.updateMainSwitchPosition}
                            residentialAllPartsAvailable={this.state.residentialAllPartsAvailable}
                        />
                    </Modal>
                }

                <div className="app__header">
                    <header className="header">
                        <div className="header__section hs_switchboard">
                            <div className="header__bar">
                                <div className="header-logo-container">
                                    <HeaderLogo />
                                    <span className="divider"></span>
                                    {this.props.isCommercial ? <HeaderBrandCommercial /> : <HeaderBrandResidential />}
                                </div>
                                <h2 className="h5 header__title">{this.state.board.Name}</h2>

                                <button className="button button--3 button-edit" onClick={() => this.startConfiguringBoard()}>
                                    <span className="button__icon">
                                        <span className="i-edit"></span>
                                    </span>
                                    <span className="button__text">
                                        Edit Board
                                    </span>
                                </button>
                            </div>

                            <div className="header__actions">
                                <button className={'button button--2 button--view-quote' + (!this.isEnoughFilledToGenerateQuote() || !this.areEnoughBoardsToGenerateQuote() ? ' disabled' : '' +
                                    (this.state.isAddingDevice.length > 0 ? ' is-loading' : ''))}
                                    onClick={() => this.viewQuote()}>
                                    <span className="button__icon">
                                        <span className="i-document"></span>
                                    </span>
                                    <span className="button__text">
                                        View Quote
                                    </span>
                                </button>

                                <button className="button button--outline button-add" onClick={() => this.addNewBoard()}>
                                    <span className="button__icon">
                                        <span className="i-plus"></span>
                                    </span>
                                    <span className="button__text">
                                        <span className="button__text-lg">Add &nbsp;</span>Board
                                    </span>
                                </button>

                                <Link className="button button--outline button-close" to={CONST.PAGES.PROJECT_DETAILS_RESIDENTIAL + '?orderID=' + this.state.projectID}>
                                    <span className="button__icon">
                                        <span className="i-close"></span>
                                    </span>
                                    <span className="button__text">
                                        <span className="button__text-lg">Close &nbsp;</span>Board
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </header>
                </div>

                <div className="app__body is-residential">
                    <div className="board__sidebar">
                        <div className="breadcrumbs">
                            <Link className="breadcrumb" to="/?showResidential=true">My Residential Projects</Link>
                            <Link className="breadcrumb" to={CONST.PAGES.PROJECT_DETAILS_RESIDENTIAL + '?orderID=' + this.state.projectID}>
                                {this.state.project.Title}
                            </Link>
                            <span className="breadcrumb">{this.state.board.Name}</span>
                        </div>

                        {/* <!-- Sidebar Header --> */}
                        <h2 className="sidebar__title h3">My Library</h2>
                        <div className="sidebar__header">
                            <button className="button button--1" onClick={() => { this.startAddingBreaker() }}>
                                <span className="button__icon">
                                    <span className="i-plus"></span>
                                </span>
                                <span className="button__text">
                                    Add Breaker
                                </span>
                            </button>
                            <button className="button button--outline" onClick={() => { this.startAddingAdditionalItems() }}>
                                <span className="button__icon">
                                    <span className="i-plus"></span>
                                </span>
                                <span className="button__text">
                                    Add Additional Items
                                </span>
                            </button>
                        </div>

                        <div className="tabs tabs--sidebar">
                            <div className={'tab' + (this.state.activeBreakersTab === 'all' ? ' is-active' : '')}
                                onClick={() => this.setState({ activeBreakersTab: 'all' })}>
                                <div className="tab__text">
                                    All
                                </div>
                            </div>
                            <div className={'tab' + (this.state.activeBreakersTab === 'favourites' ? ' is-active' : '')}
                                onClick={() => this.setState({ activeBreakersTab: 'favourites' })}>
                                <span className="i-favourite"></span>
                                <div className="tab__text">
                                    Favourites
                                </div>
                            </div>
                            <div className={'tab' + (this.state.activeBreakersTab === 'boardonly' ? ' is-active ' : '')}
                                onClick={() => this.setState({ activeBreakersTab: 'boardonly' })}>
                                <span className="i-switchboard"></span>
                                <div className="tab__text">
                                    This board only
                                </div>
                            </div>
                        </div>

                        {/* <!-- Sidebar Body --> */}
                        <div className={'sidebar__body' + (this.state.isDragAndDropEnabled ? ' is-drag-drop' : ' is-auto-placement')}>
                            {this.state.board.ProjectBoardBreakerToolboxCollection.length === 0 &&
                                this.state.board.ProjectBoardContactorToolboxCollection.length === 0 &&
                                this.state.board.ProjectBoardFittedOptionToolboxCollection.length === 0 &&
                                <div className="board-message-mute">
                                    <svg width="38" height="64" viewBox="0 0 38 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M36.0326 46.66L36.0029 46.7221L35.982 46.7876C35.9142 47.0005 35.7386 47.1712 35.5703 47.2298L35.5114 47.2504L35.4556 47.278L33.9424 48.0277L33.3863 48.3032V48.9237V58.5026V58.5889L33.4011 58.6739C33.4851 59.1568 33.1681 59.5462 32.8607 59.5998L32.8396 59.6035L32.8187 59.608L17.3149 63H17.1045C17.0403 63 16.9536 62.9856 16.8563 62.9516C16.8263 62.9412 16.7982 62.9299 16.7726 62.9185C16.6937 62.8357 16.6093 62.7739 16.5309 62.7287L1.75428 49.8361L1.74648 49.8293L1.73855 49.8227C1.57654 49.6871 1.45972 49.4727 1.45972 49.1736V5.19428C1.45972 5.06099 1.49986 4.92751 1.57152 4.81041C1.6456 4.68935 1.73575 4.6143 1.79916 4.58114L1.94489 4.50493L1.99842 4.44895C2.00967 4.445 2.0219 4.44069 2.03246 4.43689C2.05841 4.42756 2.09145 4.41536 2.12931 4.3998L17.7102 1.00829C17.8259 0.984928 17.9864 1.00564 18.1352 1.13017L18.1714 1.16043L18.2102 1.18715L32.864 11.2658L32.9137 11.3L32.9517 11.3198C32.9578 11.3246 32.9719 11.3358 32.9945 11.3565C33.045 11.4028 33.1011 11.4609 33.1857 11.5494L33.9085 10.8583L33.1857 11.5494C33.3184 11.6881 33.3818 11.7968 33.4109 11.8813C33.4359 11.954 33.4512 12.0516 33.4137 12.2084L33.3863 12.323V12.4409V22.5195V22.8167L33.5486 23.0656L35.9012 26.6743C36.0623 27.0156 36.0941 27.1244 36.0941 27.184V46.4249C36.0941 46.447 36.09 46.4858 36.0767 46.537C36.0635 46.5875 36.0461 46.6318 36.0326 46.66ZM3.67491 5.63244L2.88424 5.8017V6.61029V48.424V48.8789L3.2272 49.1778L14.6954 59.1731L16.3524 60.6174V58.4193V51.1727C16.3524 50.9287 16.4983 50.653 16.7933 50.4656L18.4263 49.6523L18.9805 49.3763V48.7572V31.0988V30.8043L18.8209 30.5569L16.5464 27.0295C16.3843 26.6864 16.3524 26.5772 16.3524 26.5176V15.4395C16.3524 15.1604 16.4541 14.9551 16.5993 14.8187C16.6912 14.7611 16.7946 14.7194 16.9778 14.6548L28.5438 12.1691L30.8022 11.6838L28.9028 10.3692L18.0718 2.87273L17.7162 2.62662L17.2933 2.71714L3.67491 5.63244ZM32.0415 13.0327L30.8291 13.2962L18.5645 15.9616L17.7769 16.1328V16.9388V25.9345V26.2189L17.9265 26.4607L19.6786 29.2927L20.0522 29.8965L20.7454 29.7429L32.771 27.0774L34.1658 26.7683L33.3979 25.5636L32.1599 23.6215C32.0748 23.4286 32.0415 23.2578 32.0415 23.1025V14.2734V13.0327ZM33.882 45.9861L34.6696 45.8149V45.0089V29.5162V28.2755L33.4572 28.539L21.1927 31.2044L20.405 31.3756V32.1816V47.6743V48.915L21.6174 48.6515L33.882 45.9861ZM31.2538 58.3969L32.0415 58.2258V57.4198V49.1736V47.928L30.8253 48.1973L19.9146 50.6128L19.7972 50.6388L19.6892 50.6919L18.3353 51.3583L17.7769 51.6331V52.2555V60.0852V61.3258L18.9893 61.0624L31.2538 58.3969Z" fill="#CBCBCB" stroke="#F3F2F2" strokeWidth="2" />
                                    </svg>
                                    <p>You don’t have any devices in your library yet.</p>
                                    <p><strong>Add your first device above</strong></p>
                                </div>
                            }

                            {/* Render Breakers */}
                            {this.state.board.ProjectBoardBreakerToolboxCollection.length > 0 &&
                                <div className="breakers" style={{ overflow: "hidden", clear: "both" }}>
                                    {
                                        this.state.activeBreakersTab !== 'favourites' &&
                                        <p>Breakers</p>
                                    }
                                    {this.state.board.ProjectBoardBreakerToolboxCollection.map((toolboxItem, index) => {
                                        toolboxItem.quantity = toolboxItem.quantity === undefined ? 1 : toolboxItem.quantity
                                        if (this.state.activeBreakersTab === 'all' ||
                                            (this.state.activeBreakersTab === 'favourites' && this.isBreakerFavourite(toolboxItem.BreakerTypeItemID)) ||
                                            (this.state.activeBreakersTab === 'boardonly' && !this.isBreakerFavourite(toolboxItem.BreakerTypeItemID))) {

                                            const breakerObj = this.state.breakerOptionData.find(dataItem => dataItem.ItemID === toolboxItem.BreakerTypeItemID)

                                            const availabilityDataForSelectedBreaker = this.state.residentialAllPartsAvailable.find(item => item.ItemCode === breakerObj.Reference)
                                            let validationMessage = ''
                                            validationMessage = this.getValidationMessage(availabilityDataForSelectedBreaker, breakerObj.Description)

                                            return (
                                                <>
                                                    <Breaker
                                                        key={index}
                                                        ItemID={toolboxItem.ItemID}
                                                        poleCount={parseInt(breakerObj.SpaceUsed, 10)}
                                                        BreakerTypeItemID={toolboxItem.BreakerTypeItemID}
                                                        description={breakerObj.Description}
                                                        isDragAndDropEnabled={this.state.isDragAndDropEnabled}
                                                        handleDeletingBreaker={(itemID) => { this.handleDeletingBreaker(itemID) }}
                                                        isBreakerFavourite={this.isBreakerFavourite(toolboxItem.BreakerTypeItemID)}
                                                        quantity={toolboxItem.quantity}
                                                        handleToggleBreakerFavourite={(itemID) => { this.handleToggleBreakerFavourite(itemID) }}
                                                        usedCount={this.getUsedCount(breakerObj)}
                                                        isDisabled={false} // It's always enabled, leave it for now, as there could be conditions where it's not enabled
                                                        handleBreakerAutoAdd={(itemID, quantity) => {
                                                            quantity = parseInt(quantity)
                                                            for (let i = 0; i < quantity; i++) {
                                                                setTimeout(() => {
                                                                    this.autoAddbreaker(itemID, toolboxItem.BreakerTypeItemID)
                                                                }, 0);
                                                            }
                                                        }}
                                                        addBreakerToBoard={(rowIndex, poleIndex, ItemID, BreakerTypeItemID) => {
                                                            this.handleBreakerDrop(rowIndex, poleIndex, ItemID, BreakerTypeItemID)
                                                        }}
                                                        handleUpdateQuantity={(quantity, itemID) => { this.handleUpdateQuantity(quantity, itemID) }}
                                                    />
                                                    {validationMessage &&
                                                        <div className="modal__validation-msg">
                                                            <span className="alert__icon">
                                                                <span className="i-exclamation"></span>
                                                            </span>
                                                            <span dangerouslySetInnerHTML={{ __html: validationMessage }}></span>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        } else {
                                            return ''
                                        }
                                    })}
                                </div>
                            }

                            {/* Render Additinal items */}
                            {(this.state.board.ProjectBoardContactorToolboxCollection.length > 0 ||
                                this.state.board.ProjectBoardFittedOptionToolboxCollection.length > 0) &&
                                <div className="breakers" style={{ overflow: "hidden", clear: "both" }}>
                                    {
                                        this.state.activeBreakersTab !== 'favourites' &&
                                        <p>Additional Items</p>
                                    }
                                    {this.state.board.ProjectBoardContactorToolboxCollection.map((toolboxItem, index) => {
                                        toolboxItem.quantity = toolboxItem.quantity === undefined ? 1 : toolboxItem.quantity
                                        if (this.state.activeBreakersTab === 'all' || this.state.activeBreakersTab === 'boardonly') {
                                            const contactorObj = toolboxItem.ContactorReadOnly

                                            const availabilityDataForSelectedBreaker = this.state.residentialAllPartsAvailable.find(item => item.ItemCode === toolboxItem?.ContactorReadOnly?.Rating)
                                            let validationMessage = ''
                                            validationMessage = this.getValidationMessage(availabilityDataForSelectedBreaker, toolboxItem.ContactorReadOnly.Description)

                                            return (
                                                <>
                                                    <Contactor
                                                        key={index}
                                                        ItemID={toolboxItem.ItemID}
                                                        poleCount={parseInt(contactorObj.SpaceUsed, 10)}
                                                        ContactorItemID={toolboxItem.ContactorItemID}
                                                        description={contactorObj.Description}
                                                        isDragAndDropEnabled={this.state.isDragAndDropEnabled}
                                                        quantity={toolboxItem.quantity}
                                                        handleDeletingContactor={(itemID) => { this.handleDeletingContactor(itemID) }}
                                                        usedCount={this.getUsedContactorCount(contactorObj)}
                                                        isDisabled={false}
                                                        handleContactorAutoAdd={(itemID, quantity) => { 
                                                            quantity = parseInt(quantity)
                                                            for (let i = 0; i < quantity; i++) {
                                                                setTimeout(() => {
                                                                    this.autoAddContactor(itemID, toolboxItem.ContactorItemID) 
                                                                }, 0)
                                                            }
                                                        }}
                                                        addContactorToBoard={(rowIndex, poleIndex, ItemID, ContactorItemID) => {
                                                            this.handleContactorDrop(rowIndex, poleIndex, ItemID, ContactorItemID)
                                                        }}
                                                        handleContactorUpdateQuantity={(quantity, itemID) => { this.handleContactorUpdateQuantity(quantity, itemID) }}
                                                    />
                                                    {validationMessage &&
                                                        <div className="modal__validation-msg">
                                                            <span className="alert__icon">
                                                                <span className="i-exclamation"></span>
                                                            </span>
                                                            <span dangerouslySetInnerHTML={{ __html: validationMessage }}></span>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        } else {
                                            return ''
                                        }
                                    })}

                                    {this.state.board.ProjectBoardFittedOptionToolboxCollection.map((toolboxItem, index) => {
                                        toolboxItem.quantity = toolboxItem.quantity === undefined ? 1 : toolboxItem.quantity
                                        if (this.state.activeBreakersTab === 'all' || this.state.activeBreakersTab === 'boardonly') {
                                            const fittedOptionObj = toolboxItem.FittedOptionReadOnly

                                            const availabilityDataForSelectedBreaker = this.state.residentialAllPartsAvailable.find(item => item.ItemCode === toolboxItem?.FittedOptionReadOnly?.Reference)

                                            let validationMessage = ''
                                            validationMessage = this.getValidationMessage(availabilityDataForSelectedBreaker, toolboxItem.FittedOptionReadOnly?.Description)

                                            return (
                                                <>
                                                    <FittedOption
                                                        key={index}
                                                        ItemID={toolboxItem.ItemID}
                                                        poleCount={parseInt(fittedOptionObj.SpaceUsed, 10)}
                                                        FittedOptionItemID={toolboxItem.FittedOptionItemID}
                                                        description={fittedOptionObj.Description}
                                                        isDragAndDropEnabled={this.state.isDragAndDropEnabled}
                                                        quantity={toolboxItem.quantity}
                                                        handleDeletingFittedOption={(itemID) => { this.handleDeletingFittedOption(itemID) }}
                                                        usedCount={this.getUsedFittedOptionCount(fittedOptionObj)}
                                                        isDisabled={false}
                                                        handleFittedOptionAutoAdd={(itemID, quantity) => { 
                                                            quantity = parseInt(quantity)
                                                            for (let i = 0; i < quantity; i++) {
                                                                setTimeout(() => {
                                                                    this.autoAddFittedOption(itemID, toolboxItem.FittedOptionItemID) 
                                                                }, 0)
                                                            }
                                                        }}
                                                        addFittedOptionToBoard={(rowIndex, poleIndex, ItemID, FittedOptionItemID) => {
                                                            this.handleFittedOptionDrop(rowIndex, poleIndex, ItemID, FittedOptionItemID)
                                                        }}
                                                        handleFittedOptionUpdateQuantity={(quantity, itemID) => { this.handleFittedOptionUpdateQuantity(quantity, itemID) }}
                                                    />
                                                    {validationMessage &&
                                                        <div className="modal__validation-msg">
                                                            <span className="alert__icon">
                                                                <span className="i-exclamation"></span>
                                                            </span>
                                                            <span dangerouslySetInnerHTML={{ __html: validationMessage }}></span>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        } else {
                                            return ''
                                        }
                                    })}
                                </div>
                            }
                        </div>

                        {/* <!-- Sidebar Footer --> */}
                        <div className="sidebar__footer">
                            <div className="sidebar__footer-inner">
                                <div className="sidebar__actions">
                                    <label className="switch">
                                        <input type="checkbox" className="switch__input" checked={!this.state.isDragAndDropEnabled}
                                            onChange={() => this.setState({ isDragAndDropEnabled: !this.state.isDragAndDropEnabled })} />

                                        <div className="switch__button switch__button--on">
                                            <span className="switch__button-icon">
                                                <span className="i-drag"></span>
                                            </span>
                                            <span className="switch__button-text">Drag and Drop</span>
                                        </div>
                                        <span className="switch__slider slider round"></span>
                                        <div className="switch__button switch__button--off">
                                            <span className="switch__button-icon">
                                                <span className="i-plus"></span>
                                            </span>
                                            <span className="switch__button-text">Auto Placement</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Sidbar */}
                    <div className="board__container">
                        <div className="alert-container">
                            {
                                this.state.pageInfo !== '' &&
                                <p className="alert alert--success">
                                    <span className="alert__icon">
                                        <span className="i-check-circle"></span>
                                    </span>
                                    <span className="alert__text">
                                        {this.state.pageInfo}
                                    </span>
                                </p>
                            }

                            {
                                this.state.isEditingPowerTags &&
                                <p className="alert alert--success">
                                    <span className="alert__icon">
                                        <span className="i-check-circle"></span>
                                    </span>
                                    <span className="alert__text">
                                        Power Tags will be supplied loose, and not fitted to the board.
                                    </span>
                                </p>
                            }

                            {
                                this.state.hasMixedDifferentProductRanges &&
                                <p className="alert alert--success">
                                    <span className="alert__icon">
                                        <span className="i-check-circle"></span>
                                    </span>
                                    <span className="alert__text">
                                        You have mixed 6kA and 4.5kA. Please note that these breakers belong to different product ranges and that their appearance on the board will be different.
                                    </span>
                                </p>
                            }

                            {
                                this.state.apiError !== '' &&
                                <p className="alert alert--error">
                                    <span className="alert__icon">
                                        <span className="i-exclamation"></span>
                                    </span>
                                    <span className="alert__text">
                                        {this.state.apiError}
                                    </span>
                                </p>
                            }

                            {
                                this.state.displayMaxBoardLimitReached &&
                                <p className="alert alert--error">
                                    <span className="alert__icon">
                                        <span className="i-exclamation"></span>
                                    </span>
                                    <span className="alert__text">
                                        You have reached the maximum number of boards per project and cannot ADD or COPY anymore.
                                    </span>
                                </p>
                            }
                        </div>

                        <div ref={this.scrollRef} onScroll={this.onScroll} className={'board__container-scroll' + (this.state.isDragAndDropEnabled ? ' drag-n-drop' : ' auto-placement')}>
                            <div className="board-width">
                                <ChassisBoardResidential
                                    boardName={this.state.board.Name}
                                    breakers={this.getChassisBoardBreakers()}
                                    contactors={this.state.board.ProjectBoardContractorCollection}
                                    fittedOptions={this.state.board.ProjectBoardFittedOptionCollection}
                                    busbars={this.state.board.ProjectBoardBusbarCollection}
                                    breakerData={this.state.breakerOptionData}
                                    polesNeeded={this.state.boardDetails.PolesNeeded}
                                    surgeProtection={this.state.boardDetails.SurgeProtection}
                                    surgeProtectionDetails={this.state.boardDetails.SurgeProtectionDetails}
                                    mainSwtchIncomingPhases={BoardService.getMainSwitchIncomingPhasesPoles(this.state.boardDetails.IncomerPhase)}
                                    mainSwitchRating={this.state.boardDetails.MainSwitchRating}
                                    mainSwitchPosition={parseInt(this.state.board.MainSwitchPosition, 10)} // Array based value, e.g. value 10 will be placed on position 11
                                    deleteCallback={this.deleteBreakerFromBoard}
                                    deleteContactorCallback={this.deleteContactorFromBoard}
                                    deleteFittedOptionCallback={this.deleteFittedOptionFromBoard}
                                    togglePowerTagCallback={this.togglePowerTag}
                                    updateBrekerChassisNote={this.updateBrekerChassisNote}
                                    updateContactorChassisNote={this.updateContactorChassisNote}
                                    updateFittedOptionChassisNote={this.updateFittedOptionChassisNote}
                                    updateBreakerPosition={this.updateBreakerPosition}
                                    updateContactorPosition={this.updateContactorPosition}
                                    updateFittedOptionPosition={this.updateFittedOptionPosition}
                                    updateMainSwitchPosition={this.updateMainSwitchPosition}
                                    updateWiserEnergyGatewayPosition={this.updateWiserEnergyGatewayPosition}
                                    removeBusbar={this.removeBusbar}
                                    hasWiserEnergyGateway={this.state.board.HasWiserEnergyGateway}
                                    wiserEnergyGatewayRow={this.state.board.WiserEnergyGatewayRow}
                                    wiserEnergyGatewayPosition={this.state.board.WiserEnergyGatewayPosition}
                                    total={this.state.boardPolesTotal}
                                    remaining={this.state.boardPolesRemaining}
                                    configured={this.state.boardPolesConfigured}
                                    percentageConfigured={this.state.boardCompletionPercentage}
                                    openBusbarModalCallback={() => this.startCreatingBusbar()}
                                    updatePowerTagsEditing={(isEditingPowerTags) => this.setState({ isEditingPowerTags: isEditingPowerTags })}
                                    isEditingPowerTags={this.state.isEditingPowerTags}
                                    isUpdatingDevice={this.state.isUpdatingDevice}
                                    canAddDeviceToPosition={(speceUsed, rowIndex, poleIndex, isMainSwitch, breakerItemID) => {
                                        return this.canAddDeviceToPosition(speceUsed, rowIndex, poleIndex, false, isMainSwitch, breakerItemID)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {
                    this.state.isConfiguringBoard &&
                    <BoardDetailsResidential
                        board={this.state.boardToConfigure}
                        boardOptions={this.state.boardOptions}
                        boardOptionData={this.state.boardOptionData}
                        breakerOptionData={this.state.breakerOptionData}
                        deleteBreakerFromBoard={this.deleteBreakerFromBoard}
                        closeCallback={this.stopConfiguringBoard}
                        projectID={this.state.projectID}
                        residentialAllPartsAvailable={this.state.residentialAllPartsAvailable}
                    />
                }
            </div>

        )
    }
}

export default withRouter(ConfigChassisResidential)
